import { FormatHelper } from "../Helpers/FormatHelper.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";
import { InputSlider } from "./component/InputSlider";
import { States } from "./../states.js";
import { Modal } from "./Modal.js";
import { ThankYouModal } from "./ThankYouModal.js";
import { SeeDetails } from "./SeeDetails.js";
import { MissingFields } from "./MissingFields.js";
import { Stepper } from "./component/Stepper.js";
import { ProgressSteps } from "./ProgressSteps.js";
import { DealPageHelper } from "../Helpers/DealPageHelper.js";
import { NeedHelpForm } from "./NeedHelpForm";
import { AccessoriesSection } from "./AccessoriesSection.js";
import { EasyRideDisclaimer } from "./EasyRideDisclaimerModal.js";
import { TradeInSection } from "./TradeInSection";
import { ContactFormSection } from "./ContactFormSection.js";
import { PaymentSection } from "./PaymentSection.js";
import { SeeDetailsNotification } from "./SeeDetailsNotification.js";
import { PmDRSDatalayer } from "../Datalayer/PmDRSDatalayer.js";
import { AdditionalStepsSection } from "./AdditionalStepsSection.js";
import { TradeInDisclaimer } from "./TradeInDisclaimer.js";

export class DealPage {
    constructor(app) {
        this.app = app;
        let siteSettings = this.app.siteSettings;

        this.parentId = app.config.elementId;
        this.options = app.widget.options;
        this.classAtt = "start-deal-container";
        this.dealType = ""; //finance lease or cash
        this.dealTypeTouched = false; //true once the customer clicks a payment tab, as opposed to whichever tab loaded preselected
        this.downPaymentElement = "pmdrs-retailing-payment-slider";
        this.tradeInElement = "pmdrs-retailing-trade-in-slider";
        this.stripePaymentId = null;
        
        this.incentives = {
            aiNBC: 1000,
            aiMBC: 1000,
            aiCBC: 1000,
        };

        this.awayMessageEnable = siteSettings.awayMessageEnable;
        this.hideChatNotification = siteSettings.hide_chat_notification;
        this.onlyEasyRide = siteSettings.onlyEasyRide;
        // this.tradeInEnabled = this.setTradeInEnabled();
        // this.awayMessageEnable = false;

        this.taxes = false;
        this.accessoriesValue = 0;
        // this.dealType = this.app.isBMW() ? "balloon" : "finance";
        this.stepper = null;
        this.progressSteps = this.app.siteSettings.contactFormAtBottom ? new ProgressSteps(this.app) : null;
        this.leadId = this.app.generateLeadId();
        this.ftid = this.app.generateFTID(this.leadId);
        this.customerJourneyId = null;
        
        this.drsCustomerId = "";        
        this.vinFound = false;
        this.tradeInValue = null; //null = no valuation ever run; only a real appraisal response sets a number (possibly 0)
        this._loadingStackCount = 0;
        this._headerLoadingStackCount = 0;
    }

    // Easy Ride payment is only allowed on 'new' vehicles or BMW vehicles
    isBalloonAllowed() {
        let condition = this.app.config.vehicle.condition;
        if (condition != "new" || this.app.isBMWPolaris()) {
            this.blockEasyRideOption();
        }
    }

    showOnlyEasyRideOptions() {
        let cardsToHide = ["finance", "cash"];
        cardsToHide.forEach((elem) => {
            let card = document.querySelector(
                this.getSelector(".lease-finance-options .lease-option ." + elem + "-option")
            );
            // cash doesn't have a term
            if (elem != "cash") {
                let term = document.querySelector(
                    this.getSelector(".lease-finance-options .lease-option .term-" + elem)
                );
                DOMHelper.addClass(term, "dn");
            }
            DOMHelper.addClass(card, "dn");
        });
    }

    setHtmlImages(){
        this.addVideoCallIcon();
    }

    /**
     * created to enable sections after submit contact information
     */
    enableSections(){
        if(this.isAccessoriesSectionAllowed()){
            this.accessoriesSection.enable();
        }

        if(this.getTradeInEnable()){
            this.tradeInSection.enable();
        }
        this.paymentSection.enable();
        this.uncollapseSections();
    }

    /**
     * created to disable sections that requires contact information to be submitted
     */
    disableSections(){
        if(this.isAccessoriesSectionAllowed()){
            this.accessoriesSection.disable();
        }
        if(this.getTradeInEnable()){
            this.tradeInSection.disable();
        }
        this.paymentSection.disable();
        this.collapseSections();
    }

    /**
     * Collapse every gray card down to just its title, matching Figma's
     * "Disabled Sections" frame — the locked/initial state. Contact
     * Information is the only card available from the start, so it's
     * excluded here.
     */
    collapseSections(){
        DOMHelper.addClass(this.getSelector('.deal-page-section:not(.contact-form-section)'), 'collapsed');
    }

    /**
     * Expand every gray card back to full content — called alongside
     * enableSections() once Contact Information unlocks the rest.
     */
    uncollapseSections(){
        DOMHelper.removeClass(this.getSelector('.deal-page-section'), 'collapsed');
    }

    getMake() {
        return this.app.config.vehicle.make;
    }

    setBackgroundColor() {
        let make = this.make;
        let background = "";
        if (make.toLowerCase() == "indian motorcycle") {
            // black background
            background = "indian-background";
        } else {
            // blue backgroud
            background = "bmw-background";
        }
        // contact info step
        DOMHelper.addClass(this.getSelector(".vehicle-info-mobile"), background);
        DOMHelper.addClass(this.getSelector("#progress-bar-container"), background);
        // trade in step
        DOMHelper.addClass(this.getSelector(".trade-in-step"), background);
        // accessories step
        DOMHelper.addClass(this.getSelector(".start-accessory-modal"), background);
        // payment steop
        DOMHelper.addClass(this.getSelector(".payment-step"), background);
        // footer
        DOMHelper.addClass(this.getSelector(".footer-chat-container-contaier"), background);
        // additional steps
        DOMHelper.addClass(this.getSelector(".additional-steps"), background);
        // general
        DOMHelper.addClass(this.getSelector("#deal-page-form"), background);
        DOMHelper.addClass(this.getSelector(".steps-controls"), background);
        this.needHelpForm.setBackgroundColor(this.make);
        this.FormSubmission.setBackground(this.make);
        if (this.tradeInEnabled) {
            this.dragDrop.setBackgroundColor(this.make);
        }
    }

    init() {
        this.setHtmlImages();
        this.showChatNotificationOrNot();
        this.make = this.app.config.vehicle.make;

        // single site rule: bmwmotorcyclesofchulavista hides the payment header bar under either
        // unlocked-sections design (contactFormAtBottom or sectionsUnlockedByDefault)
        if (this.app.pmdrs.config.accountId === "bmwmotorcyclesofchulavista"
            && (this.app.siteSettings.contactFormAtBottom || this.app.siteSettings.sectionsUnlockedByDefault)) {
            let headerInfoSection = document.querySelector(this.getSelector(".header-info-section"));
            if (headerInfoSection) headerInfoSection.style.display = "none";
        }

        let minCashDown = this.app.config.vehicle.finalPrice * 0;
        let maxCashDown = this.app.config.vehicle.finalPrice * 0.6;

        // twilio form modal
        this.needHelpForm = new NeedHelpForm(this.app);
        this.needHelpForm.init();

        // progress steps (only when contactFormAtBottom design is enabled)
        if (this.app.siteSettings.contactFormAtBottom) {
            this.progressSteps.init(document.querySelector(this.getSelector(".progress-steps-section")));
        }

        // contact form at classic position (before accessories) when new design is off
        if (!this.app.siteSettings.contactFormAtBottom) {
            this.contactFormSection = new ContactFormSection(this.app);
            this.contactFormSection.init(this.getFormElement());
            this.contactFormSection.setBackground(this.make);
        }

        //accessories
        if(this.isAccessoriesSectionAllowed()) {
            this.accessoriesSection = new AccessoriesSection(this.app);        
            this.accessoriesSection.init(this.getFormElement());        
            this.accessoriesSection.setBackground(this.make);
        }else{
            console.log('skip accessories section');
            this.removeAccessoriesScrollDot();        
        }

        //trade in
        if(this.getTradeInEnable()){            
            this.tradeInSection = new TradeInSection(this.app);
            this.tradeInSection.init(this.getFormElement());
            this.tradeInSection.setBackground(this.make);
            this.missingFields = new MissingFields(this.app);
            this.missingFields.init();
        }else{            
            console.log('skip tradein section');
            this.removeTradeInScrollDot();
        }

        //payment
        this.paymentSection = new PaymentSection(this.app);
        this.paymentSection.init(this.getFormElement());
        this.paymentSection.setBackground(this.make);
        this.paymentSection.hideTradeInValueInformation();

         // see details
        this.seeDetails = new SeeDetails(this.app);
        this.seeDetails.init();
        this.seeDetails.hideTradeInValueInformation();

        // contact form at bottom position (after payment/seeDetails) when new design is enabled
        if (this.app.siteSettings.contactFormAtBottom) {
            this.contactFormSection = new ContactFormSection(this.app);
            this.contactFormSection.init(this.getFormElement());
            this.contactFormSection.setBackground(this.make);
        }

        // additional steps
        this.additionalStepsSection = new AdditionalStepsSection(this.app);
        this.additionalStepsSection.init(this.getFormElement());
        this.additionalStepsSection.setBackground(this.make);

        // trade in modal
        this.tradeInDisclaimer = new TradeInDisclaimer(this.app);
        this.tradeInDisclaimer.init();

        // form submission modal
        this.thankYouModal = new ThankYouModal(this.app);        
        this.thankYouModal.init();
        this.thankYouModal.setBackground(this.make);

        this.updateVehicleInformation();
        // this.setUrlToEasyRideLink();
        
        this.eventHandlers();

        if (this.app.isLampedodge()) {
            this.rearrangeSectionsForLampedodge();
        }

        if (this.app.isSouthbayChryslerJeepDodgeRam()) {
            this.rearrangeSectionsForSouthbay();
            this.renameCashBoxForSouthbay();
        }

        //DISABLE SECTIONS (not needed when contact form is at the bottom, or when sectionsUnlockedByDefault opts a site out of the lock — sections are open by default in both cases)
        if (!this.app.siteSettings.contactFormAtBottom && !this.app.siteSettings.sectionsUnlockedByDefault) {
            this.disableSections();
        }
        // this.getSessionVars();

        return;

        // this.stepper = this.setUpDealPageAsStepper();
        // this.stepper.addHtmlStepNumbers("stepper-place");
        // this.stepper.init();
        // // CHANGE SUBMIT BTN TEXT
        // let submitBtnPosition = this.accessories.length == 0 ? 2 : 3;
        // var steps = document.querySelectorAll("#deal-page-stepper .pm-drs-step");
        // if (steps[submitBtnPosition]) {
        //     steps[submitBtnPosition].querySelector(".submit-step-btn").textContent = "Finish & Send";
        // }

        // this.setInitialWidth(this.accessories);
        // this.hideFirstNextBtn();
        // this.hideAllTradeInValue();

        // this.downPaymentSlider = new InputSlider(
        //     this.app,
        //     this.downPaymentElement,
        //     "downPaymentField",
        //     minCashDown,
        //     maxCashDown,
        //     true
        // );
        // this.downPaymentSlider.init();
        // this.downPaymentSlider.setValue(1000);

        // this.tradeInSlider = new InputSlider(this.app, this.tradeInElement, "tradeInValueField", 0, maxCashDown, true);
        // this.tradeInSlider.init();    

        // // notifications area modal
        // this.seeDetailsNotification = new SeeDetailsNotification(this.app);
        // this.seeDetailsNotificationModal = new Modal(
        //     this.app,
        //     "start-details-notifications",
        //     this.seeDetailsNotification.getHmtl(),
        //     null,
        //     "notification-area-class"
        // );
        // this.seeDetailsNotificationModal.init();
        // this.seeDetailsNotification.init();       

        // // easy ride disclaimer modal
        // this.easyRideDisclaimer = new EasyRideDisclaimer(this.app);
        // this.easyRideDisclaimerModal = new Modal(
        //     this.app,
        //     "start-easyridedisclaimer-modal",
        //     this.easyRideDisclaimer.getHtml(),
        //     null,
        //     "easyridedisclaimer-class"
        // );
        // this.easyRideDisclaimerModal.init();
        // this.easyRideDisclaimer.init();
        // // form submission modal
        // this.FormSubmission = new FormSubmission(this.app);
        // this.submissionModal = new Modal(
        //     this.app,
        //     "start-submission-container",
        //     this.FormSubmission.getHtml(),
        //     null,
        //     "submission-class"
        // );
        // this.submissionModal.init();
        // this.FormSubmission.init();

        // // trade in disclaimer modal
        // this.tradeInDisclaimer = new TradeInDisclaimer(this.app);
        // this.tradeInDisclaimerModal = new Modal(
        //     this.app,
        //     "start-trade-in-disclaimer",
        //     this.tradeInDisclaimer.getHtml(),
        //     null,
        //     "trade-in-disclaimer-class"
        // );
        // this.tradeInDisclaimerModal.init();
        // this.tradeInDisclaimer.init();

        // this.setBackgroundColor();

        // this.setHeaderInfo();
        // this.setContactUsPhoneNumber();
        // if (this.getTradeInEnable() && this.app.isBMW()) {
        //     this.populateYearTradeInSelect();
        // } else if (this.getTradeInEnable() && !this.app.isBMW()) {
        //     this.showTradeInWithFields();
        // } else {
        //     this.disableTradeIn();
        // }
        // this.populateConditionTradeInSelect();

        
        // this.setTCPA_CCPA();        
        // this.addIconIfSafari();
        // this.showChatNotificationOrNot();

        // // this.verifyEnableOptions();

        // let accessoriesSize = this.accessories.length;
        // this.getAccessories(accessoriesSize);

        

        // this.hideSubmitButton();
        // this.setDataInNotificationSection();

        // this.getDealerProfileSettings();

        // this.isBalloonAllowed();
        // if (this.onlyEasyRide) this.showOnlyEasyRideOptions();

        // //Down payment only on bmwdrs or dev
        // if (
        //     this.app.pmdrs.config.accountId == "bmwdrs" ||
        //     this.app.pmdrs.config.accountId == "genesis" ||
        //     this.app.pmdrs.config.accountId == "indian4"
        // ) {
        //     document.querySelector(this.getSelector(".down-payment-container")).style.display = "block";
        // }
        // this.showIncentives();
        // this.setValuesCheckbox();
        // this.updateCSRIncentives();
    }

    showChatNotificationOrNot() {
        if (this.hideChatNotification) {
            let footerChat = document.querySelector(this.getSelector(".footer-chat-container-contaier")); // for v1
            if (footerChat) {
                footerChat.style.display = "none";
            }
            let headerChat = document.querySelector(this.getSelector(".header-info-section .rightcol .need-help-btn"));
            if (headerChat) {
                headerChat.style.visibility = "hidden";
                headerChat.closest(".header-info-section").classList.add("chat-hidden");
            }
        }
    }

    showZipCodeDisclaimer() {
        if(this.app.pmdrs.config.accountId != 'gotorcauto') return;
        let zipcodeDisclaimer = document.querySelector(this.getSelector(".zipcode-disclaimer"));
        zipcodeDisclaimer.style.display = "block";
    }

    showLoading() {
        this._loadingStackCount++;
        document.querySelector(".deal-page-spinner").style.display = "block";
    }

    hideLoading() {
        if(--this._loadingStackCount > 0) return;//skip until the stack count is zero
        document.querySelector(".deal-page-spinner").style.display = "none";
    }

    showHeaderLoading() {
        this._headerLoadingStackCount++;
        document.querySelector(this.getSelector(".mypayment-loading")).style.display = "block";
    }

    hideHeaderLoading() {
        if(--this._headerLoadingStackCount > 0) return;//skip until the stack count is zero
        document.querySelector(this.getSelector(".mypayment-loading")).style.display = "none";
    }

    getDealerProfileSettings() {
        let siteToken = this.app.pmdrs.config.accountId;
        let data = {
            siteToken: siteToken,
        };
        this.app.pmdrs.pmApiDtm.getDealerProfileSettings(
            data,
            (success) => {
                let settings = JSON.parse(success);
                if (!this.isItOpen(settings) || this.getAwayMessage()) {
                    let awayMessage = document.querySelector(this.needHelpForm.getSelector(".away-message"));
                    awayMessage.style.display = "flex";
                    let timeToCall = document.querySelector(this.needHelpForm.getSelector(".preferred-time-to-call"));
                    timeToCall.style.display = "block";
                }
            },
            (error) => {}
        );
    }

    // the idea is to convert the hours to minutes and then make the comparison
    isItOpen(settings) {
        let today = new Date();
        let weekdays = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
        let dayOfWeek = weekdays[today.getDay()];
        let key = "dp_sales_dept_hrs_" + dayOfWeek;
        let currentHour = today.getHours();
        let currentMinutes = today.getMinutes();
        let currentTime = parseInt(currentHour * 60) + parseInt(currentMinutes);
        let hours = settings[key];
        let openHours =
            hours != "Closed"
                ? hours
                      .replace(/[A-Z]+/g, "")
                      .split(" - ")
                      .map((item) => {
                          return item.split(":");
                      })
                : false;

        if (openHours == false) return false;

        let openTime = parseInt(openHours[0][0] * 60) + parseInt(openHours[0][1]);
        let eveninigHour = parseInt(openHours[1][0]) + 12;
        let closedTime = parseInt(eveninigHour * 60) + parseInt(openHours[1][1]);

        return currentTime > openTime && currentTime < closedTime;
    }


    hideFirstNextBtn() {
        let btnNext = document.querySelector(
            this.stepper.getSelector("button.btn-next[data-index_target='" + 1 + "']")
        );
        btnNext.style.display = "none";
    }



    showAdditionalStepsInfo() {
        this.additionalStepsSection.populateAdditionalStepsSection();
    }

    validateScheduleTestRide() {
        let valid = true;
        let ids = ["TRFirstName", "TRLastName", "TRPhone", "TREmail", "testRideDate"];

        ids.forEach((id) => {
            let element = document.querySelector(this.getSelector("#" + id));
            let error = document.querySelector(this.getSelector("." + id + "-error"));
            if (element.value.length == 0) {
                error.style.display = "block";
                valid = false;
            } else {
                error.style.display = "none";
            }
        });

        return valid;
    }

    validatePreApprovedForm() {
        let valid = true;
        let ids = [
            "PAName",
            "PALastName",
            "PAPhone",
            "PAEmail",
            "PAStreet",
            "PAAddressLine2",
            "PACity",
            "PAState",
            "PAZipCode",
        ];

        ids.forEach((id) => {
            let element = document.querySelector(this.getSelector("#" + id));
            let error = document.querySelector(this.getSelector("." + id + "-error"));
            if (element.type === "text") {
                if (element.value.length == 0) valid = false;
                error.style.display = element.value.length == 0 ? "block" : "none";
            } else {
                if (element.value == "default") valid = false;
                error.style.display = element.value == "default" ? "block" : "none";
            }
        });

        return valid;
    }

    // if trade in is disable, hide the trade in the payment step
    disableTradeIn() {
        let tradeInElement = this.getSelector(".retailing-trade-in");
        DOMHelper.addClass(tradeInElement, "dn");
    }

    setDataInNotificationSection() {
        DOMHelper.setInnerHTML(this.getSelector(".notification-year"), this.app.config.vehicle.year);
        DOMHelper.setInnerHTML(this.getSelector(".notification-make"), this.app.config.vehicle.make);
        DOMHelper.setInnerHTML(this.getSelector(".notification-model"), this.app.config.vehicle.model);
    }

    hideAllTradeInValue() {
        let tradeInValuePaymentStep = document.querySelector(this.getSelector(".retailing-trade-in"));
        let elems = [tradeInValuePaymentStep];
        elems.forEach((elem) => {
            elem.classList.add("d-none");
        });
    }

    setTCPA_CCPA_deprecated() {
        if (this.app.isBMW()) {
            // hide lease option. BMW does not handle lease payment option
            document.querySelector(this.getSelector(".lease-option div.lease-option")).style.display = "none";
            document.querySelector(this.getSelector(".lease-option div.term-lease")).style.display = "none";
        } else if (this.isBMWPolaris) {
            document.querySelector(this.getSelector(".lease-option div.lease-option")).style.display = "none";
            document.querySelector(this.getSelector(".lease-option div.term-lease")).style.display = "none";
            document.querySelector(this.getSelector(".lease-option div.balloon-option")).style.display = "none";
            document.querySelector(this.getSelector(".lease-option div.term-balloon")).style.display = "none";
            document.querySelector(this.getSelector(".vehicle-disclaimer")).style.display = "none";
        } else {
            // hide easy ride option
            document.querySelector(this.getSelector(".lease-option div.balloon-option")).style.display = "none";
            document.querySelector(this.getSelector(".lease-option div.term-balloon")).style.display = "none";
            // hide "Disclaimer" text, since that disclaimer is to show Easy Ride information
            document.querySelector(this.getSelector(".vehicle-disclaimer")).style.display = "none";
        }
        return this.app.pmdrs.pmDealersite.getCCPATCPADescriptions(
            (response) => {
                this.consents = JSON.parse(response);
                // let ccpa = document.querySelector(this.getSelector(".ccpa-description"));
                // let tcpa = document.querySelector(this.getSelector(".tcpa-description"));
                // ccpa.textContent = this.consents.ccpa;
                // tcpa.textContent = this.consents.tcpa;
                DOMHelper.setTextContent(this.getSelector(".ccpa-description span"), this.consents.ccpa);
                DOMHelper.setTextContent(this.getSelector(".tcpa-description span"), this.consents.tcpa);
                DOMHelper.setValue(this.getSelector(".tcpa_desc_hinput"), this.consents.tcpa);
                DOMHelper.setValue(this.getSelector(".ccpa_desc_hinput"), this.consents.ccpa);
            },
            (error) => {
                console.log(error);
            }
        );

        // document.querySelector(this.getSelector(".container-tcpa-ccpa")).style.display = "none";
    }

    

    verifyEnableOptions() {
        let types = ["finance", "balloon", "lease"];
        types.forEach((elem) => {
            if (!this.options.hasOwnProperty(elem)) {
                document.querySelector(this.getSelector(".lease-option div." + elem + "-option")).style.display =
                    "none";
            }
        });
    }

    setRequiredToContactInformation() {
        let stepContactInformation = this.getSelector(".step-contact-information-number");
        DOMHelper.setInnerHTML(stepContactInformation, "(<span class='required'>*</span> Required)");
    }

    setStepNumbers(includeAccessories) {
        // select all the step-class-number fields
        let stepContactInformation = this.getSelector(".step-contact-information-number");
        // let stepTaxes = this.getSelector(".step-step-taxes-number");
        let stepTradeIn = this.getSelector(".step-trade-number");
        let stepAccessories = this.getSelector(".step-accessories-number");
        let stepPaymentOptions = this.getSelector(".step-payment-options-number");
        let stepCreditScore = this.getSelector(".step-credit-score-number");
        let stepScheduleDelivery = this.getSelector(".step-schedule-delivery-number");

        // set the text to the steps
        DOMHelper.setInnerHTML(stepContactInformation, "1. ");
        // DOMHelper.setInnerHTML(stepTaxes, "2. ");
        DOMHelper.setInnerHTML(stepTradeIn, "2. ");
        if (includeAccessories && this.getTradeInEnable()) {
            DOMHelper.setInnerHTML(stepAccessories, "3. ");
            DOMHelper.setInnerHTML(stepPaymentOptions, "4. ");
            DOMHelper.setInnerHTML(stepCreditScore, "5. ");
            DOMHelper.setInnerHTML(stepScheduleDelivery, "6. ");
        } else if (includeAccessories && !this.getTradeInEnable()) {
            DOMHelper.setInnerHTML(stepAccessories, "2. ");
            DOMHelper.setInnerHTML(stepPaymentOptions, "3. ");
        } else {
            DOMHelper.setInnerHTML(stepPaymentOptions, "3. ");
            DOMHelper.setInnerHTML(stepCreditScore, "4. ");
            DOMHelper.setInnerHTML(stepScheduleDelivery, "5. ");
            // let accessories = document.querySelector(
            //     this.getSelector(".step-accessories")
            // );
            // accessories.style.display = "none";
        }
    }

    setContactUsPhoneNumber() {
        // this.app.pmdrs.pmApi.getSiteSettings(
        //     this.app.pmdrs.config.accountId,
        //     (response) => {
        //         let settings = JSON.parse(response);
        //         let phoneNumber = document.querySelectorAll(this.getSelector(".contact-us-phone"));
        //         phoneNumber.forEach((phone) => {
        //             phone.href = "tel:" + settings.custom_header;
        //             phone.text = settings.custom_header;
        //         });
        //     },
        //     (error) => {
        //         console.log(error);
        //     }
        // );

        let settings = this.app.siteSettings;
        let phoneNumber = document.querySelectorAll(this.getSelector(".contact-us-phone"));
        phoneNumber.forEach((phone) => {
            phone.href = "tel:" + settings.custom_header;
            phone.text = settings.custom_header;
        });
    }


    setHeaderInfo() {
        let vehicleInfo = document.querySelector(this.getSelector(".vehicle-info .vehicle-details"));
        let vehicleInfoMb = document.querySelector(this.getSelector(".vehicle-info-mobile .vehicle-details"));
        let smallHeader = '<p class="see-details" id="see-details">See Details</p>';
        vehicleInfo.innerHTML = "";
        vehicleInfoMb.innerHTML = "";
        let bigHeader =
            '<div class="header-text"><span class="vehicle-lease dealPage-creditScore" id="credit-score-dealPage" style="font-weight: 700;">Credit Score: <span class="credit-score" style="font-weight: 100;"></span></span>' +
            "<br id='credit-score-dealPage'>" +
            '<span class="vehicle-lease" style="font-weight:700;">MSRP: <span class="vehicle-msrp" style="font-weight:100;"></span>' +
            "<br>" +
            '<span class="vehicle-lease" style="font-weight: 700;">APR: <span class="apr-header" style="font-weight:100;"></span></span>' +
            "<br>" +
            '<span class="vehicle-lease" style="font-weight: 700;">Cash Down: <span class="downpayment-header" style="font-weight: 100;"></span></span>' +
            "<br>" +
            '<span class="vehicle-lease" style="font-weight: 700;">Trade In Value: <span class="trade-in-header" style="font-weight: 100;"></span>' +
            "<br>" +
            '<span class="vehicle-lease" style="font-weight: 700;">Accessories: <span class="accessories-header" style="font-weight: 100;">$0</span></span></div>' +
            '<div class="header-error-text vehicle-lease" style="color:red; display:none"><span>Please enter different values</span></div>' +
            '<div class="header-error-finance vehicle-lease" style="color:red; display:none"><span>Amount financed must be at least $2500</span></div>' +
            '<div class="header-lead-error vehicle-lease" style="color:red; display:none"><span>PLEASE VERIFY YOUR VALUES BEFORE SUBMIT</span></div>';

        vehicleInfo.innerHTML += smallHeader;
        vehicleInfoMb.innerHTML += smallHeader;
        vehicleInfo.innerHTML += bigHeader;

        let seeDetails = document.querySelector(this.getSelector("#see-details"));
        let headerInfo = document.querySelector(this.getSelector(".header-text"));

        if (window.innerWidth <= 768) {
            headerInfo.style.display = "none";
        } else {
            seeDetails.style.display = "none";
        }
    }

    setDealType(type) {
        this.dealType = type;
    }

    setValuesCheckbox() {
        for (var incentive in this.incentives) {
            let incentiveValue = this.incentives[incentive];
            let incentiveCheckbox = document.querySelector(
                ".drs-checkbox.drs-checkbox-" + incentive + " [type='checkbox']"
            );
            incentiveCheckbox.dataset.cash = incentiveValue;

            // checkbox.dataset.cash = incentiveValue;
            let cash = document.querySelector(".drs-checkbox.drs-checkbox-" + incentive + " .drs-value-" + incentive);
            cash.textContent = "$" + incentiveValue;
        }
    }

    getHtml() {
        return `<div class="start-deal-container">
	<div class="pmdrspanel">
		<div class="trigger-element" data-index="1" style="margin-bottom: 0;"></div>

		<!-- Floating Scrolling Dots -->
		<div class="bmwdrs-floatnav-container">
			<div class="bmwdrs-floatnav">
				<div class="itm"><a data-target=1><span class="dot active"></span></a></div>
				<div class="itm"><a data-target=2><span class="dot"></span></a></div>
				<div class="itm"><a data-target=3><span class="dot"></span></a></div>
				<div class="itm"><a data-target=4><span class="dot"></span></a></div>
			</div>
		</div>

		<div class="close-button-section">
			<a href="#" aria-label="Close">&times;</a>
		</div>

		
		<!-- Header redesign: the vehicle thumbnail is no longer shown above the header
     bar per direction — commented out (not deleted) for future reference.
<div class="vehicle-image">
    <img src="data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 400 240%27%3E%3Crect width=%27400%27 height=%27240%27 fill=%27%23f4f5f6%27/%3E%3Cg fill=%27none%27 stroke=%27%23d7dade%27 stroke-width=%276%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M60 150 L90 100 Q100 90 115 90 L285 90 Q300 90 310 100 L340 150%27/%3E%3Crect x=%2740%27 y=%27150%27 width=%27320%27 height=%2750%27 rx=%2710%27/%3E%3Ccircle cx=%27110%27 cy=%27200%27 r=%2720%27 fill=%27%23f4f5f6%27/%3E%3Ccircle cx=%27290%27 cy=%27200%27 r=%2720%27 fill=%27%23f4f5f6%27/%3E%3C/g%3E%3C/svg%3E" onerror="this.onerror=null;" class="vehicle-img">
</div>
-->

<!-- Tiny, fixed-size sentinel watched by an IntersectionObserver in
     DealPage.registerStickyHeaderHandler() to detect when the header should
     stick. Deliberately NOT part of .header-info-section: its own height
     never changes, so toggling .drs-sticky (which does change the header's
     height) can't shift this element and feed back into the trigger — that
     feedback loop is what caused the stick/unstick jitter near the boundary
     with the old scrollTop-vs-offsetTop math. -->
<div class="sticky-header-sentinel"></div>

<div class="header-info-section">
    <div class="name-and-close">
        <div class="vehicle-name"></div>
        <span class="submit-drs-close" role="button" tabindex="0">Close</span>
    </div>
    <div class="leftcol">
        <div class="standardtxt mypayment-label">My Payment</div>
        <div class="mypayment-value">$--/mo</div>
        <!-- <div class="standardtxt taxmonths">plus tax for <span class="mypayment-months-value">60</span> months</div> -->
        <!-- Header redesign: See Details / Disclaimer removed from the header
             per direction — commented out (not deleted) for future reference.
        <div class="disclaimer-toggle"><span class="seedetails"><a class="vehicle-details">See Details</a> | </span><a class="disclaimer-title">Disclaimer</a></div>
        -->
        <div class="zipcode-disclaimer" style="display: none;" >We've updated your rates based on the ZIP code you entered.</div>
        <!-- <div id="header-info-disclaimer" class="disclaimer-text" style="display: none;">Estimated payments exclude applicable taxes, title, registration, license, and documentary fees, and will vary depending upon the final price and terms agreed upon between you and your BMW Dealer.</div> -->
         <div class="mypayment-error dn"></div>
        <div class="pmdrs-loading-wrapper mypayment-loading"><div class="lds-dual-ring"></div></div>
    </div>
    <div class="rightcol">
        <button class="need-help-btn color-white">
            <i class="pmdrs-fa pmdrs-fa-videocamera"></i>
            <div class="videochat-text">Video Chat</div>
        </button>
        <button class="need-help-btn color-white" style="display:none">
            <i class="pmdrs-fa pmdrs-fa-phone"></i>
            <div class="videochat-text">Talk To Sales</div>
        </button>
    </div>
</div>
		<div class="progress-steps-section"></div>
		
		<form class="deal-page-form">
			<input type="hidden" name="form_title" value="Speed DRA">
			<div class="deal-page-spinner">
				<div class="spinner-container">
    <div class="spinner2"></div>
</div>
			</div>
			
		</form>

		<!-- disabled by the moment -->
		<div class="footer-chat-container-contaier" style="display: none">
			<div class="footer-chat-container d-flex">
				<div class="footer-chat d-flex" id="submitFloatButton">
    <div class="video-call-icon">
        <img id="img-video-call-icon" src="" alt="">
    </div>
    <div class="video-call-txt">
        Questions? Let Us Help You Chat <br>
        Or Visit via Video Now
    </div>
</div>
			</div>
		</div>
	</div>
</div>`;
    }

    updateCSRIncentives() {
        let dealPage = this;
        for (var incentive in this.incentives) {
            let checkbox = this.getIncentivesCheckbox(incentive);
            this.registerIncentivesHandler(checkbox);
        }
        // this.app.getCSRIncentives(this.dealType, (response) => {
        //     response = JSON.parse(response);
        //     // console.log(response);
        //     // console.log(response[0]);
        //     let firstVehicleGroup = response[0];
        //     let firstDealScenario = firstVehicleGroup.programDealScenarios[0];
        //     let firstProgram = firstDealScenario.programs[0];
        //     // console.log('items')
        //     let incentivesHtml = "";
        //     firstProgram.consumerSpecials.forEach((item) => {
        //         // console.log(item)
        //         incentivesHtml += dealPage.getIncentiveItemHTML(
        //             item.specialProgramName,
        //             item.cash
        //         );
        //     });
        //     DOMHelper.setInnerHTML(
        //         dealPage.getSelector(".pmdrs-csr-incentives"),
        //         incentivesHtml
        //     );
        //     dealPage.registerIncentivesHandler(
        //         dealPage.getSelector(
        //             ".pmdrs-csr-incentives .pmdrs-deal-incentive-item"
        //         )
        //     );
        // });
    }

    registerIncentivesHandler(incentivesSelector) {
        let dealPage = this;

        let incentiveClick = function () {
            let incentivesTotal = 0;
            DOMHelper.querySelectorAction(dealPage.getSelector(".drs-checkbox [type='checkbox']:checked"), (item) => {
                incentivesTotal += parseFloat(item.dataset.cash);
            });

            let dataPayment = dealPage.getPaymentParams(dealPage.dealType);
            dataPayment.totalIncentives = incentivesTotal;

            dealPage.app.getPayment(
                true,
                dealPage.dealType,
                dataPayment,
                (paymentObject) => {
                    dealPage.app.paymentData[dealPage.dealType] = paymentObject;
                    dealPage.updatePricingDetail();
                },
                (error) => {
                    console.log(error);
                }
            );
        };

        DOMHelper.addHandler(incentivesSelector, "click", incentiveClick);
        // let incentiveClick = function (event) {
        //     //TOGGLE INCENTIVE
        //     let incentiveDiv = event.target;
        //     console.log(incentiveDiv);
        //     if (DOMHelper.hasClass(incentiveDiv, "active")) {
        //         DOMHelper.removeClass(incentiveDiv, "active");
        //     } else {
        //         DOMHelper.addClass(incentiveDiv, "active");
        //     }

        //     //UPDATE MONTHLY PAYMENT
        //     let totalIncentives = 0;
        //     DOMHelper.querySelectorAction(
        //         dealPage.getSelector(".pmdrs-deal-incentive-item.active"),
        //         (item) => {
        //             totalIncentives += parseFloat(item.dataset.cash);
        //         }
        //     );
        //     let paymentData = dealPage.app.paymentData;
        //     paymentData.totalIncentives = totalIncentives;

        //     dealPage.app.getMonthlyPayment(
        //         true,
        //         dealPage.dealType,
        //         paymentData,
        //         (response) => {
        //             let paymentsData = JSON.parse(response);
        //             dealPage.updatePricingDetail(paymentsData);
        //             // dealPage.app.widget.updateMonthlyPayment(dealPage.dealType);
        //         },
        //         (errorResponse) => {
        //             console.log(errorResponse);
        //             alert("API error, check console");
        //         }
        //     );
        // };

        // DOMHelper.addHandler(incentivesSelector, "click", incentiveClick);
    }

    showIncentives() {
        try {
            let incentivesHtml = "";
            for (const incentive of this.app.config.vehicle.pricing.data.incentive.items) {
                incentivesHtml += this.getIncentiveItemHTML(incentive.name, incentive.value);
            }
            DOMHelper.setInnerHTML(this.getSelector(".pmdrs-deal-incentives"), incentivesHtml);
        } catch (error) {
            console.log(error);
        }
    }

    

    getIncentiveItemHTML(name, cash) {
        return (
            "<div class='pmdrs-deal-incentive-item' data-cash='" +
            cash +
            "'>" +
            "<p>" +
            name +
            "</p>" +
            "<span>" +
            FormatHelper.currencyFormat(cash) +
            "</span> </div>"
        );
    }

    

    getIncentivesCheckbox(name) {
        return document.querySelector(this.getSelector(".drs-checkbox-" + name));
    }

    populateMilesPerYearSelect(type) {
        let options = "";
        let select = this.getRetailingTypeSelect(type);
        let oldValue = select.value;
        let leaseValues = this.app.leaseTable();
        let leases = {};
        for (var lease in leaseValues) {
            let leaseValue = leaseValues[lease];
            options += "<option value='" + leaseValue["mpy"] + "'>" + leaseValue["mpy"] + "</option>";
            leases[leaseValue["mpy"]] = leaseValues[lease];
        }

        select.innerHTML = options;
        if (leaseValues.some((element) => element.mpy === oldValue)) {
            // console.log("keep old value " + oldValue);
            select.value = oldValue;
        }
    }

    

    populateConditionTradeInSelect() {
        let conditionSelect = this.getRetailingTypeSelect("condition-trade-in");
        if (conditionSelect) {
            let defaultOption = "<option value='default'>Select Condition</option>";
            let options =
                "<option value='Excellent'>Excellent</option>" +
                "<option value='Good'>Good</option>" +
                "<option value='Fair'>Fair</option>";
            conditionSelect.innerHTML += defaultOption;
            conditionSelect.innerHTML += options;
            conditionSelect.value = "default";
        }
    }

    populateDefaultValuesTradeInSelect() {
        let yearSelect = this.getRetailingTypeSelect("year-trade-in");
        let makeNameSelect = this.getRetailingTypeSelect("make-name-trade-in");
        let modelSelect = this.getRetailingTypeSelect("model-trade-in");
        let trimSelect = this.getRetailingTypeSelect("trim-trade-in");
        let optionMakeName = "<option value='default'>Select Make</option>";
        let optionModel = "<option value='default'>Select Model</option>";
        let optionTrim = "<option value='default'>Select Trim</option>";
        yearSelect.value = "default";
        makeNameSelect.innerHTML = optionMakeName;
        modelSelect.innerHTML = optionModel;
        trimSelect.innerHTML = optionTrim;
    }

    showTradeInWithFields() {
        DOMHelper.addClass(this.getSelector(".trade-in-no-vin"), "d-none");
    }
    

    populateStatesSelect() {
        let options = "<option value='default'>Select a state</option>";
        // let select = this.getRetailingTypeSelect("state");
        let select = this.getRetailingTypeSelect("pastate");
        Object.keys(States).forEach((state) => {
            options += "<option value='" + States[state] + "'>" + States[state] + "</option>";
        });
        select.innerHTML = options;
    }

    /*
    let zipCodeEvent = function () {
            let zipcCodeValue = document.querySelector("#tfZipCode").value;
            dealPage.app.pmdrs.pmApi.getTaxesByZipcode(
                zipcCodeValue,
                (response) => {
                    let taxes = JSON.parse(response);
                    taxes = taxes[0];
                    console.log(taxes);
                    let totalTaxes =
                        taxes.estimatedCityRate +
                        taxes.estimatedCombinedRate +
                        taxes.estimatedCountyRate +
                        taxes.estimatedSpecialRate +
                        taxes.stateRate;

                    let vehiclePrice = dealPage.app.getVehicleRetailPrice();
                    let fees = vehiclePrice * totalTaxes;
                    dealPage.app.config.vehicle.finalPrice =
                        vehiclePrice + fees;
                    dealPage.updateMonthlyPayment(dealPage.dealType);
                    let msg = document.createElement("p");
                    let node = document.createTextNode("Taxes applied");
                    msg.style.color = "green";
                    msg.style.paddingLeft = "20px";
                    msg.appendChild(node);
                    let taxesMsg = document.querySelector(".taxes-fees-right");
                    taxesMsg.appendChild(msg);
                    setTimeout(() => {
                        msg.remove();
                    }, 3000);
                    this.taxes = true;
                },
                (error) => {
                    console.log(error);
                }
            );
        };
     */

    addVideoCallIcon() {
        let callIcon = document.querySelector(this.getSelector(".img-video-call-icon"));
        if (callIcon) callIcon.src = this.app.pmdrs.pmApi.getRootURL() + "dist/img/video-chat-icon.png";
    }

    defaultNotTradeIn() {
        let notTradeIn = document.querySelector(this.getSelector("#notIncludeTrade"));
        if (notTradeIn) {
            //IT COULD NOT EXIST this.getTradeInEnable()
            notTradeIn.click();
        }
    }    

    hideThingsFromVlp() {
        document.querySelector(this.getSelector(".miles-per-year")).style.display = "none";
        DOMHelper.setInnerHTML(this.getSelector(".vehicle-name"), this.app.config.vehicle.label);
        document.querySelector(this.getSelector(".drs-input-poBalloon")).checked = true;
        let vNameYearMake = this.app.config.vehicle.year + " " + this.app.config.vehicle.make;
        DOMHelper.setInnerHTML(this.getSelector(".vehicle-name-year-make"), vNameYearMake);
        let vNameTrimModel = this.app.config.vehicle.model + " " + this.app.config.vehicle.trim;
        DOMHelper.setInnerHTML(this.getSelector(".vehicle-name-trim-model"), vNameTrimModel);
        this.defaultNotTradeIn();
    }

    

    updateCashHeaderValue() {
        return;
    }
    

    updatePriceByAccessories() {
        let accessories = 0;
        let accessoriesSelected = document.querySelectorAll(".accessory-selected");
        let seeDetailsButton = document.querySelector(this.getSelector("a.vehicle-details"));
        let accSelectedTxt = document.querySelector(this.getSelector(".accessories-selected-txt"));
        // let accList = document.querySelector(this.getSelector(".accessories-list"));
        let li = "";
        let accInstallationIncludedTxt = document.querySelector(this.getSelector(".acc-installation-costos-included"));
        if (accessoriesSelected.length > 0) {
            accessoriesSelected.forEach((selected) => {
                let price = selected.querySelector(".accessory-img").dataset.price;
                price = parseFloat(price.toString().replace(",", ""));
                let installationPrice = selected.querySelector(".accessory-img").dataset.installation;
                installationPrice = parseFloat(installationPrice.toString().replace(",", ""));
                price += parseFloat(installationPrice);
                accessories += parseFloat(price);
                // let vehiclePrice = this.app.getVehicleRetailPrice();                
                // this.app.config.vehicle.finalPrice = vehiclePrice + accessories;//DO NOT edit vehicle price
                this.accessoriesValue = accessories;
                // this.paymentSection.updateCashValue();//JD removed, I think it was used on prev UI

                let accName = selected.querySelector(".accessory-img").dataset.title;
                if (installationPrice > 0) {
                    li +=
                        "<i style='display: block;' class='acc-list-elem'>" +
                        accName +
                        " - $" +
                        price.toFixed(2) +
                        "*</i>";
                } else {
                    li +=
                        "<i style='display: block;' class='acc-list-elem'>" +
                        accName +
                        " - $" +
                        price.toFixed(2) +
                        "</i>";
                }
                // accList.innerHTML = "";
                DOMHelper.setInnerHTML(this.getSelector(".accessories-header"), "");
                DOMHelper.setInnerHTML(this.getSelector(".accessories-header"), "$" + accessories.toFixed(2));
                DOMHelper.setInnerHTML(this.getSelector(".deal-accessories"), "$" + accessories.toFixed(2));
                DOMHelper.setInnerHTML(this.getSelector(".vinfo-acc-price-value"), accessories.toFixed(2));
                if (seeDetailsButton) {
                    DOMHelper.setInnerHTML(
                        this.seeDetails.getSelector(".accessories-header"),
                        "$" + accessories.toFixed(2)
                    );
                }
            });
            // accList.innerHTML = li;
            accSelectedTxt.style.display = "block";
            accInstallationIncludedTxt.style.display = "block";
            accSelectedTxt.textContent = accessoriesSelected.length;
        } else {
            // accList.innerHTML = "";
            accSelectedTxt.style.display = "none";
            accInstallationIncludedTxt.style.display = "none";
            // let vehiclePrice = this.app.config.vehicle.finalPrice - this.accessoriesValue;
            // this.app.config.vehicle.finalPrice = vehiclePrice;//DO NOT edit vehicle price
            this.accessoriesValue = 0;
            // this.paymentSection.updateCashValue();//JD removed, I think it was used on prev UI
            DOMHelper.setInnerHTML(this.getSelector(".accessories-header"), "$0");
            DOMHelper.setInnerHTML(this.getSelector(".vinfo-acc-price-value"), "0.00");
            if (seeDetailsButton) {
                DOMHelper.setInnerHTML(this.seeDetails.getSelector(".accessories-header"), "$0");
            }
        }        
        this.paymentSection.refreshAllPayments();
    }

    updateVehicleInformation() {
        // Only overwrite the placeholder photo baked into the HTML when there's a real one —
        // an empty imgUrl (seen with fake/test vehicle data) would otherwise set src="", which
        // browsers resolve to the current page URL rather than firing an error the <img>'s
        // onerror fallback could catch.
        if (this.app.config.vehicle.imgUrl) {
            DOMHelper.setAttribute(this.getSelector(".vehicle-image img"), 'src', this.app.config.vehicle.imgUrl);
        }
        DOMHelper.setAttribute(this.getSelector(".vehicle-image img"), 'alt', this.app.config.vehicle.label || '');
        DOMHelper.setInnerHTML(this.getSelector(".vehicle-name"), this.app.config.vehicle.label);
        this.seeDetails.updateVehicleInformation();
        // document.querySelector(this.getSelector(".vehicle-img-mobile")).src = this.app.config.vehicle.imgUrl;
        // let container =
        //     "<div class='drs-tooltip'>Note<span class='drs-tooltiptext'>This is the dealer zip code, if you want to change it, please fill free to do it." +
        //     "</span></div>";
        // let zipCodeContainer = document.querySelector(this.getSelector(".taxes-container .drs-input-right"));
        // zipCodeContainer.innerHTML += container;
        
        // document.querySelector(this.getSelector("#tfZipCode")).value = this.app.pmdrs.config.dealerZipCode;
        // DOMHelper.setInnerHTML(this.getSelector(".vehicle-msrp"), "$" + this.app.config.vehicle.finalPrice);
        
        // let leaseText =
        //     "Lease for " +
        //     FormatHelper.currencyFormat(this.app.paymentData.monthlyPayment) +
        //     "plus tax for " +
        //     this.app.paymentData.loanMonths;
        // DOMHelper.setInnerHTML(this.getSelector(".vehicle-lease"), leaseText);
    }    

    getRetailingTypeSelect(type) {
        return document.querySelector(this.getSelector(".retailing-" + type + "-select"));
    }

    

    errorTradeIn(containerTradeInMessage, msg) {
        let node = document.createTextNode(
            "We could not find the VIN you sent, please fill out the form below to add you Trade In"
        );
        msg.style.color = "red";
        msg.style.fontSize = "15px";
        msg.appendChild(node);
        containerTradeInMessage.appendChild(msg);
        document.querySelector(this.getSelector(".trade-in-no-vin")).style.display = "none";
        document.querySelector(this.getSelector(".trade-in-no-vin-input-text")).style.display = "block";
    }

    registerNextEvents(selector) {
        let dealPage = this;
        DOMHelper.addHandler(selector, "click", function (event) {
            let indexTarget = event.target.dataset.index_target;

            dealPage.validation(indexTarget);
        });
    }

    registerStepButtonsEvents(selector) {
        let dealPage = this;
        DOMHelper.addHandler(selector, "click", function (event) {
            let target = event.target.dataset.index_target;

            dealPage.validateTopStepperButtons(target);
        });
    }

    validateTopStepperButtons(index) {
        if (index == 0) {
            if (!this.stepper.steps[this.stepper.currentStep].validation()) {
                let validate = parseInt(this.stepper.currentStep) + 1;
                this.validation(validate.toString());
            } else {
                let validate = parseInt(this.stepper.currentStep) + 2;
                this.validation(validate.toString());
            }
        }

        this.validation((parseInt(this.stepper.currentStep) + 1).toString());
    }

    validation(dataIndexTarget) {
        let stepBtn = "";
        switch (dataIndexTarget) {
            case "1":
                stepBtn = document.querySelector("li.step-btn[data-index_target='0']");
                stepBtn.classList.remove("pmdrs-fa");
                stepBtn.classList.add("pmdrs-fa");
                console.log("validation contact info");
                if (this.validateContactInformation()) {
                    stepBtn.classList.remove("pmdrs-fa-exclamation-triangle");
                    stepBtn.classList.remove("error");
                    stepBtn.classList.add("pmdrs-fa-check");
                    stepBtn.classList.add("success");
                } else {
                    stepBtn.classList.remove("pmdrs-fa-check");
                    stepBtn.classList.remove("success");
                    stepBtn.classList.add("pmdrs-fa-exclamation-triangle");
                    stepBtn.classList.add("error");
                }
                break;

            case "2":
                console.log("validating tradein");
                stepBtn = document.querySelector("li.step-btn[data-index_target='1']");
                stepBtn.classList.remove("pmdrs-fa");
                stepBtn.classList.add("pmdrs-fa");
                if (this.getTradeInEnable()) {
                    if (this.validateTradeIn()) {
                        console.log("true");
                        stepBtn.classList.remove("pmdrs-fa-exclamation-triangle");
                        stepBtn.classList.remove("error");
                        stepBtn.classList.add("pmdrs-fa-check");
                        stepBtn.classList.add("success");
                    } else {
                        console.log("false");
                        stepBtn.classList.remove("pmdrs-fa-check");
                        stepBtn.classList.remove("success");
                        stepBtn.classList.add("pmdrs-fa-exclamation-triangle");
                        stepBtn.classList.add("error");
                    }
                } else {
                    // the validation for accessories doesnt exist, so we mark it as done
                    stepBtn.classList.remove("pmdrs-fa-exclamation-triangle");
                    stepBtn.classList.remove("error");
                    stepBtn.classList.add("pmdrs-fa-check");
                    stepBtn.classList.add("success");
                }
                break;

            case "3":
                console.log("validation case 3");
                if (this.validateContactInformation() && this.getTradeInEnable() && this.validateTradeIn()) {
                    stepBtn = document.querySelector("li.step-btn[data-index_target='2']");
                    stepBtn.classList.remove("pmdrs-fa");
                    stepBtn.classList.add("pmdrs-fa");
                    stepBtn.classList.remove("pmdrs-fa-exclamation-triangle");
                    stepBtn.classList.remove("error");
                    stepBtn.classList.add("pmdrs-fa-check");
                    stepBtn.classList.add("success");

                    stepBtn = document.querySelector("li.step-btn[data-index_target='3']");
                    stepBtn.classList.remove("pmdrs-fa");
                    stepBtn.classList.add("pmdrs-fa");
                    stepBtn.classList.add("pmdrs-fa-check");
                    stepBtn.classList.add("success");
                } else {
                    stepBtn = document.querySelector("li.step-btn[data-index_target='2']");
                    stepBtn.classList.remove("pmdrs-fa");
                    stepBtn.classList.add("pmdrs-fa");
                    stepBtn.classList.remove("pmdrs-fa-check");
                    stepBtn.classList.remove("success");
                    stepBtn.classList.add("pmdrs-fa-exclamation-triangle");
                    stepBtn.classList.add("error");
                }
                break;

            case "4":
                if (this.validateTradeIn()) {
                    stepBtn = document.querySelector("li.step-btn[data-index_target='2']");
                    stepBtn.classList.remove("pmdrs-fa");
                    stepBtn.classList.add("pmdrs-fa");
                    stepBtn.classList.remove("pmdrs-fa-exclamation-triangle");
                    stepBtn.classList.remove("error");
                    stepBtn.classList.add("pmdrs-fa-check");
                    stepBtn.classList.add("success");
                }
                break;
            default:
                break;
        }
    }

    stepValidation() {
        // let formData = this.getFormData();

        // let isValid = true;
        // for (const [key, value] of Object.entries(formData)) {
        //     let domElement = document.querySelector(
        //         this.getSelector('[name="' + key + '"]')
        //     );

        //     // domElement.setCustomValidity("");

        //     let isFieldValid = domElement.reportValidity();

        //     isValid = isFieldValid && isFieldValid;
        //     if (!isValid) break;
        // }

        // return isValid && this.validateContactInformation();
        return this.validateContactInformation();
    }

    getFormElement() {
        return document.querySelector(this.getSelector(".deal-page-form"));
    }
    

    showError(domElement) {
        return (domElement.nextElementSibling.style.display = "block");
    }

    hideError(domElement) {
        return (domElement.nextElementSibling.style.display = "none");
    }

    showInputError(domElement) {
        return (domElement.nextElementSibling.nextElementSibling.style.display = "block");
    }

    hideInputError(domElement) {
        return (domElement.nextElementSibling.nextElementSibling.style.display = "none");
    }

    removeAccessoriesScrollDot(){
        let dot = document.querySelector(this.getSelector('.bmwdrs-floatnav a[data-target="2"]'))
        dot.parentNode.remove()
    }

    removeTradeInScrollDot(){
        let dot = document.querySelector(this.getSelector('.bmwdrs-floatnav a[data-target="3"]'))
        dot.parentNode.remove()
    }

    validateTradeIn() {
        let doInclude = document.querySelector(this.getSelector("#includeTrade"));
        let vinField = document.querySelector(this.getSelector("#ytiVin"));
        let elements = [];
        let dateRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;

        if (!this.vinFound && vinField.value.length == 17) {
            elements = [
                "#tradeYearField",
                "#tradeMakeField",
                "#tradeModelField",
                "#tradeTrimField",
                "condition-trade-in",
                "#ytiMiles",
                "#tradeDateField",
            ];
        } else if (vinField.value.length == 0) {
            elements = [
                "year-trade-in",
                "make-name-trade-in",
                "model-trade-in",
                "trim-trade-in",
                "condition-trade-in",
                "#ytiMiles",
                "#tradeDateField",
            ];
        } else {
            elements = ["condition-trade-in", "#ytiMiles", "#tradeDateField"];
        }
        let valid = true;
        console.log(elements);

        if (doInclude.checked) {
            elements.forEach((element) => {
                let elem = document.querySelector(this.getSelector(element)) ?? this.getRetailingTypeSelect(element);

                let elemValue = elem.value;
                // validate the drop downs
                if (elem.tagName.toLowerCase() === "select") {
                    if (elemValue == "default") {
                        valid = false;
                        DOMHelper.addClass(elem, "select-tag-error");
                        console.log(elem);
                        //DATALAYER
                        this.app.pmDRSDatalayer.validationFailedEvent(
                            PmDRSDatalayer.TRADE_IN_SECTION,
                            elem,
                            "required"
                        );
                    } else {
                        DOMHelper.removeClass(elem, "select-tag-error");
                    }
                } else {
                    //to validate the input:text
                    if (elemValue.length === 0) {
                        this.showError(elem);
                        valid = false;
                        //DATALAYER
                        this.app.pmDRSDatalayer.validationFailedEvent(
                            PmDRSDatalayer.TRADE_IN_SECTION,
                            elem,
                            "required"
                        );
                    } else {
                        this.hideError(elem);
                    }
                }
            });
            let elem = document.querySelector(this.getSelector("#tradeDateField"));
            let dateInput = document.querySelector(this.getSelector("#tradeDateField")).value;
            let date = new Date(dateInput);
            let day = date.getDate().toString().padStart(2, "0");
            let month = (date.getMonth() + 1).toString().padStart(2, "0");
            let year = date.getFullYear();

            let formatted = `${day}/${month}/${year}`;
            if (!dateRegex.test(formatted)) {
                valid = false;
                this.showInputError(elem);
                //DATALAYER
                this.app.pmDRSDatalayer.validationFailedEvent(PmDRSDatalayer.TRADE_IN_SECTION, elem, "format");
            } else {
                this.hideInputError(elem);
            }
            console.log("the value of valid is: ");
            console.log(valid);
            if (!valid) {
                document.querySelector(this.getSelector(".trade-in-error .error-msg")).style.display = "block";
            } else {
                document.querySelector(this.getSelector(".trade-in-error .error-msg")).style.display = "none";
            }
            return valid;
        }
        return true;
    }

    verifySubmitForm() {
        let modal = document.querySelector(".start-deal-container");
        modal.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
        });
        let contactInfoIcon = document.querySelector(this.getSelector("li.step-btn[data-index_target='0']"));
        let firstName = document.querySelector(this.getSelector(".ciFirstName"));
        let checkboxTCPA = document.querySelector(
            this.getSelector(".tcpa-description-container input[type='checkbox']")
        );
        let checkboxCCPA = document.querySelector(
            this.getSelector(".ccpa-description-container input[type='checkbox']")
        );
        let email = document.querySelector(this.getSelector(".ciEmail"));
        if (contactInfoIcon.classList.contains("pmdrs-fa-exclamation-triangle")) {
            if (DealPageHelper.isEmpty(firstName)) {
                DealPageHelper.showError(firstName.parentNode);
                // DealPageHelper.focus(firstName);
            } else if (DealPageHelper.isEmpty(email)) {
                DealPageHelper.showError(email.parentNode);
                // DealPageHelper.focus(email);
                if (!DealPageHelper.isChecked(checkboxCCPA) || !DealPageHelper.isChecked(checkboxTCPA)) {
                    document
                        .querySelector(this.getSelector(".container-tcpa-ccpa"))
                        .classList.add("method-of-contact-error");
                    document.querySelector(this.getSelector(".error-preferred-method")).style.display = "block";
                    // document.querySelector(this.getSelector("#contact-method-field")).focus();
                }
            }
            this.stepper.showStep("0");
            return false;
        }
        DealPageHelper.hideError(firstName.parentNode);
        DealPageHelper.hideError(email.parentNode);
        document.querySelector(this.getSelector(".container-tcpa-ccpa")).classList.remove("method-of-contact-error");
        document.querySelector(this.getSelector(".error-preferred-method")).style.display = "none";
        return true;
    }

    

    updateMonthlyPayment(type){
        this.paymentSection.updateMonthlyPayment(type);
    }

    updateCashValue(){
        this.paymentSection.updateCashValue();
    }


    showMsgInTaxes(msg, text, emptyText, taxesMsg) {
        let node = document.createTextNode(text);
        msg.appendChild(emptyText);
        msg.style.color = "green";
        msg.style.paddingLeft = "30px";
        msg.style.marginTop = "auto";
        msg.style.marginBlock = "auto";
        msg.style.fontSize = "12px";
        msg.style.display = "contents";
        msg.appendChild(emptyText);
        msg.appendChild(node);
        if (taxesMsg.querySelector("p")) taxesMsg.querySelector("p").remove();
        taxesMsg.appendChild(msg);

        setTimeout(() => {
            if (taxesMsg.querySelector("p")) taxesMsg.querySelector("p").remove();
        }, 2500);
    }

    hideSubmitButton() {
        let btnSubmit = document.querySelector(this.getSelector(".btn-submit"));
        DOMHelper.addClass(btnSubmit, "dn");
    }

    sendLead(btnSubmit, valid, data_target) {
        if (valid) {
            btnSubmit.click();
            if (data_target != 1) {
                let btnNext = document.querySelector(
                    this.stepper.getSelector("button.btn-next[data-index_target='" + data_target + "']")
                );
                if (btnNext) btnNext.click();
            }
        }
    }

    addIconIfSafari() {
        let userAgent = navigator.userAgent.toLowerCase();
        let isSafari = userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1;
        if (isSafari) {
            let descs = document.querySelectorAll(this.getSelector(".drs-input-wrapper-icon .description"));
            let wrappers = document.querySelectorAll(this.getSelector(".drs-input-wrapper-icon .drs-input-right"));
            if (wrappers) {
                wrappers.forEach((wrapper) => {
                    wrapper.classList.add("safari-input-date");
                });
            }
            if (descs) {
                descs.forEach((desc) => {
                    desc.innerHTML = "<i class='pmdrs-fa pmdrs-fa-calendar' aria-hidden='true'></i>";
                });
            }
        }
    }

    blockEasyRideOption() {
        let balloonOption = this.getSelector(".balloon-option");
        let termBalloon = this.getSelector(".term.term-balloon");
        DOMHelper.addClass(balloonOption, "add-opacity");
        DOMHelper.addClass(termBalloon, "add-opacity");

        document.querySelector(this.getSelector("#poBalloon")).disabled = true;
    }

    registerStickyHeaderHandler() {
        //sticky header
        var stickyElement = document.querySelector(this.app.getSelector(".header-info-section"));
        let drsStepperElement = this.app.siteSettings.contactFormAtBottom
            ? document.querySelector(this.app.getSelector(".progress-steps-section"))
            : null;

        // single site rule: bmwmotorcyclesofchulavista has no header bar above it (hidden in init()),
        // so the sticky progress steps bar should reach the top instead of leaving header-height space
        if (this.app.pmdrs.config.accountId === "bmwmotorcyclesofchulavista" && drsStepperElement) {
            drsStepperElement.style.top = "0px";
        }

        var modalBody = document.querySelector(this.app.getSelector('.start-deal-modal'));
        var sentinel = document.querySelector(this.app.getSelector('.sticky-header-sentinel'));
        if (!stickyElement || !modalBody || !sentinel) return;

        // the stepper sticks right under the sticky header: its height changes with the vehicle
        // name's line count and the viewport, so a fixed CSS top left a gap (or an overlap)
        if (drsStepperElement && this.app.pmdrs.config.accountId !== "bmwmotorcyclesofchulavista") {
            let placeStepper = () => {
                let headerTop = parseFloat(getComputedStyle(stickyElement).top) || 0;
                drsStepperElement.style.top = Math.floor(headerTop + stickyElement.offsetHeight) + "px";
            };
            placeStepper();
            if ("ResizeObserver" in window) new ResizeObserver(placeStepper).observe(stickyElement);
        }

        // IntersectionObserver instead of comparing modalBody.scrollTop against a fixed
        // "stickyElement.offsetTop + 200" threshold: .header-info-section's OWN height changes
        // once .drs-sticky is added (different padding for the compact look), which shifts the
        // page layout and therefore shifts scrollTop's relationship to that fixed threshold —
        // a feedback loop that visibly jittered stick/unstick right at the boundary. The sentinel
        // is a separate, fixed-size element placed just above the header, so toggling .drs-sticky
        // can never move it or feed back into the trigger — it only crosses the viewport edge
        // once, when the user actually scrolls past that point.
        var stickyObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    stickyElement.classList.add('drs-sticky');
                    if (drsStepperElement) drsStepperElement.classList.add('drs-sticky');
                } else {
                    stickyElement.classList.remove('drs-sticky');
                    if (drsStepperElement) drsStepperElement.classList.remove('drs-sticky');
                }
            });
        }, { root: modalBody, threshold: 0 });
        stickyObserver.observe(sentinel);
    }

    jumpToSecondSection(){
        let element = document.querySelector(this.getSelector('.accessories-section'))
            || document.querySelector(this.getSelector('.tradein-section'))
            || document.querySelector(this.getSelector('.your-payment-section'));
        if (!element) return;
        let stickyElement = document.querySelector(this.getSelector(".header-info-section"));
        let modal = document.querySelector(this.app.getSelector('.start-deal-modal'));
        if (!modal) return;
        modal.scrollTo({ top: element.offsetTop - stickyElement.clientHeight, behavior: 'smooth' });
    }

    scrollHandler() {
        let dealPage = this;

        function refreshActiveDot(dotTarget) {
            // remove active from all step elements
            let steps = document.querySelectorAll(dealPage.app.getSelector('.pm-step-circle'));
            steps.forEach(function(element) {
                element.classList.remove('active');
            });

            // add active to current dot
            let step = dealPage.app.getSelector('.pm-stepper-horizontal .pm-step[data-target="' + dotTarget + '"]');
            let newStepActive = document.querySelector(step);
            if (newStepActive) {
                newStepActive.classList.add('active');
            }

            let previousTarget = dotTarget - 1;
            let circle = dealPage.app.getSelector('.pm-stepper-horizontal .pm-step[data-target="' + previousTarget + '"] .pm-step-circle');
            circle = document.querySelector(circle);
            step = dealPage.app.getSelector('.pm-stepper-horizontal .pm-step[data-target="' + previousTarget + '"] .pm-step-circle span');
            newStepActive = document.querySelector(step);
            if (circle && newStepActive) {
                circle.style.backgroundColor = "#0062f1";
                newStepActive.innerHTML = "";
                newStepActive.classList.add('pmdrs-fa', 'pmdrs-fa-check');
            }
            // let stop = 1;
            // while (dotTarget <= stop) {
            //     dotTarget -= 1;
            //     let circle = dealPage.app.getSelector('.pm-stepper-horizontal .pm-step[data-target="' + dotTarget + '"] .pm-step-circle');
            //     circle.style.backgroundColor = "#0062f1";
            //     step = dealPage.app.getSelector('.pm-stepper-horizontal .pm-step[data-target="' + dotTarget + '"] .pm-step-circle span');
            //     newStepActive = document.querySelector(step);
            //     newStepActive.classList.add('pmdrs-fa pmdrs-fa-check-circle');
            // }
        }

        function jumpToDiv(dotTarget) {
            let element = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="' + dotTarget + '"]'));
            if (element) {
                let stickyElement = document.querySelector(dealPage.app.getSelector(".header-info-section"));
                let stepper = dealPage.app.siteSettings.contactFormAtBottom
                    ? document.querySelector(dealPage.app.getSelector(".progress-steps-section"))
                    : null;
                let modal = document.querySelector(dealPage.app.getSelector('.start-deal-modal'));
                let stepperHeight = stepper ? stepper.clientHeight : 0;
                modal.scrollTo(0, element.offsetTop - (stickyElement.clientHeight + stepperHeight));
            }

            refreshActiveDot(dotTarget);
        }

        function onScrollPastElement1() {
            refreshActiveDot(1);
        }
        function onScrollPastElement2() {
            refreshActiveDot(2);
        }
        function onScrollPastElement3() {
            refreshActiveDot(3);
        }
        function onScrollPastElement4() {
            refreshActiveDot(4);
        }
        function isElementInViewport(el) {
            if(!el) return;
            var rect = el.getBoundingClientRect();            
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        function handleScroll() {
            var element1 = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="1"]'));
            var element2 = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="2"]'));
            var element3 = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="3"]'));
            var element4 = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="4"]'));

            if (isElementInViewport(element1)) {
                onScrollPastElement1();
                return;
            }
            if (isElementInViewport(element2)) {
                onScrollPastElement2();
                return;
            }
            if (isElementInViewport(element3)) {
                onScrollPastElement3();
                return;
            }
            if (isElementInViewport(element4)) {
                onScrollPastElement4();
                return;
            }
        }

        DOMHelper.addHandler(this.getSelector('.pm-stepper-horizontal .pm-step'), 'click', (e) => {
            let target = event.target.dataset.target;
            jumpToDiv(target);
        });

        DOMHelper.addHandler(this.app.getSelector('.start-deal-modal'), 'scroll', handleScroll);
    }

    scrollHandlerOld(){       
        var dealPage = this;

        function refreshActiveDot(dotTarget) {
            //Remove active from all dot elements
            var dotElements = document.querySelectorAll(dealPage.app.getSelector('.dot'));
            dotElements.forEach(function(element) {
                element.classList.remove('active');
            });

            //add active to current dot
            var dotSelector = dealPage.app.getSelector('.bmwdrs-floatnav a[data-target="' + dotTarget + '"]');
            var newActiveDot = document.querySelector(dotSelector);            
            if (newActiveDot) {
                newActiveDot.classList.add('active');
            }
        }

        function jumpToDiv(dotTarget) {
            var element = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="' + dotTarget + '"]'));
            if (element) {
                var stickyElement = document.querySelector(dealPage.app.getSelector(".header-info-section"));
                var modal =  document.querySelector(dealPage.app.getSelector('.start-deal-modal'));
                modal.scrollTo(0, element.offsetTop - stickyElement.clientHeight);

            }

            refreshActiveDot(dotTarget);
        }

        function onScrollPastElement1() {
            refreshActiveDot(1);
        }

        function onScrollPastElement2() {
            refreshActiveDot(2);
        }

        function onScrollPastElement3() {
            refreshActiveDot(3);
        }

        function onScrollPastElement4() {
            refreshActiveDot(4);
        }

        function isElementInViewport(el) {
            if(!el) return;
            var rect = el.getBoundingClientRect();            
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        function handleScroll() {
            var element1 = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="1"]'));
            var element2 = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="2"]'));
            var element3 = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="3"]'));
            var element4 = document.querySelector(dealPage.app.getSelector('.trigger-element[data-index="4"]'));            

            if (isElementInViewport(element1)) {
                onScrollPastElement1();
                return;
            }

            if (isElementInViewport(element2)) {
                onScrollPastElement2();
                return;
            }

            if (isElementInViewport(element3)) {
                onScrollPastElement3();
                return;
            }

            if (isElementInViewport(element4)) {
                onScrollPastElement4();
                return;
            }
        }
        
        DOMHelper.addHandler(this.getSelector('.bmwdrs-floatnav a'), 'click',(e)=>{
            var target = event.target.dataset.target;
            jumpToDiv(target);
        });

        DOMHelper.addHandler(this.app.getSelector('.start-deal-modal'), "scroll", handleScroll);
    }

    eventHandlers() {
        let dealPage = this;

        this.scrollHandler();
        
        DOMHelper.addHandler(this.getSelector("a.vehicle-details"), 'click', () => {
            dealPage.seeDetails.seeDetailsModal.show();
        });

        // close deal modal with another button
        DOMHelper.addHandler(dealPage.getSelector(".close-button-section a"), "click", (event) => {
            event.preventDefault();
            dealPage.app.dealModal.hide();
        });
        
        

        // handling event on test ride date input
        DOMHelper.addHandler(dealPage.getSelector("#testRideDate"), "change", () => {
            let wrapper = document.querySelector(
                this.getSelector(".drs-input-wrapper-icon.testRideDate .drs-input-container")
            );
            wrapper.classList.remove("safari-input-date");
        });

        // handling event on trade in date input
        DOMHelper.addHandler(dealPage.getSelector("#tradeDateField"), "change", () => {
            let wrapper = document.querySelector(
                this.getSelector(".drs-input-wrapper-icon.tradeDateField .drs-input-container")
            );
            wrapper.classList.remove("safari-input-date");
        });        

        DOMHelper.addHandler(dealPage.getSelector("#tradeDateField"), "focus", () => {
            let elem = document.querySelector(dealPage.getSelector("#tradeDateField"));
            elem.click();
            elem.focus();
        });

        // close whole DRS from additional steps section
        DOMHelper.addHandler(dealPage.getSelector(".closeAdditionalSteps"), "click", () => {
            dealPage.thankYouModal.resetDrsForm();
        });

        DOMHelper.addHandler(dealPage.getSelector(".submit-drs-close"), "click", (event) => {
            event.preventDefault();
            dealPage.app.dealModal.hide();
        });

        DOMHelper.addHandler(dealPage.getSelector(".submit-drs-close"), "keydown", (event) => {
            if (event.key !== "Enter" && event.key !== " ") return;
            event.preventDefault();
            dealPage.app.dealModal.hide();
        });

        DOMHelper.addHandler(dealPage.getSelector(".pm-drs-modal.whole-screen"), "click", () => {
            let modal = document.querySelector(".pm-drs-modal.whole-screen");
            modal.classList.remove("backdrop-filter");
        });

        DOMHelper.addHandler(dealPage.getSelector("#see-details-notification-section"), "click", (event) => {
            event.preventDefault();
            dealPage.seeDetailsNotificationModal.show();
        });

        // Get Trade In Value Event
        DOMHelper.addHandler(dealPage.getSelector("#getTradeInValue"), "click", () => {
            let vin = document.querySelector(dealPage.getSelector("#ytiVin")).value;
            let accessToken = dealPage.app.widget.getNPAToken();
            let decodedValues = dealPage.getDecodedValues();
            let mileage = document.querySelector(this.getSelector("#ytiMiles")).value;
            let condition = this.getRetailingTypeSelect("condition-trade-in").value;

            let data = {
                sessionToken: accessToken,
                vin: vin,
                vehicleBrand: decodedValues.make,
                vehicleModel: decodedValues.model.replace(/\s/g, "") + decodedValues.trim.replace(/\s/g, ""),
                vehicleYear: decodedValues.year,
                useEstimates: true,
            };

            if (
                vin.length == 0 &&
                (decodedValues.make.length == 0 || decodedValues.model.length == 0 || decodedValues.year.length == 0)
            ) {
                DealPageHelper.showElement("#tradeInValueMissingFields");
            } else if (mileage.length == 0 || condition == "default") {
                dealPage.showError(document.querySelector(dealPage.getSelector("#ytiMiles")));
                document.querySelector(this.getSelector(".error-condition-trade-in")).style.display = "block";
                DealPageHelper.showElement("#tradeInValueMissingFields");
            } else {
                dealPage.showLoading();
                let successCallback = (response) => {
                    let value = JSON.parse(response);
                    console.log(value);
                    if (value.success == true) {
                        dealPage.vinFound = true;
                        dealPage.hideError(document.querySelector(dealPage.getSelector("#ytiMiles")));
                        document.querySelector(this.getSelector(".error-condition-trade-in")).style.display = "none";
                        let tradeInRange = this.getTradeInRange(mileage, condition, value);
                        this.tradeInValue = tradeInRange;
                        DOMHelper.setInnerHTML("#trade-in-value", tradeInRange);
                        DOMHelper.setInnerHTML(
                            this.app.dealPage.seeDetails.getSelector(".tradeinvalue-header"),
                            tradeInRange
                        );
                        DOMHelper.setInnerHTML(this.getSelector(".deal-trade-in-value"), tradeInRange);
                        let vehicleName = decodedValues.year + " " + decodedValues.make + " " + decodedValues.model;
                        this.app.dealPage.tradeInDisclaimer.updateValues(tradeInRange, condition, mileage, vehicleName);
                        this.app.dealPage.tradeInDisclaimerModal.show();
                        DealPageHelper.showElement(this.getSelector("#tradeInValueField"));
                        DealPageHelper.hideElement("#tradeInValueError");
                        DealPageHelper.hideElement("#tradeInValueMissingFields");
                        DealPageHelper.showElement("#tradeInValueSuccess");
                    }
                    dealPage.hideLoading();
                };
                let errorCallback = () => {
                    DealPageHelper.hideElement("#tradeInValueSuccess");
                    DealPageHelper.showElement("#tradeInValueError");
                };
                this.app.pmdrs.NPAApi.getTradeInValue(data, successCallback, errorCallback);
            }
        });

        DOMHelper.addHandler(dealPage.getSelector(".submit-step-btn"), "click", (event) => {
            let data_target = event.target.dataset["index_target"];
            let btnSubmit = document.querySelector(this.getSelector(".btn-submit"));
            let valid = true;
            var datalayerSection = PmDRSDatalayer.CONTACT_INFO_SECTION;
            switch (data_target) {
                case "1":
                    console.log("case 1");
                    valid = this.validateContactInformation();
                    this.sendLead(btnSubmit, valid, data_target);
                    break;

                case "2":
                    datalayerSection = PmDRSDatalayer.TRADE_IN_SECTION;
                    valid = this.getTradeInEnable() ? this.validateTradeIn() : true;
                    this.sendLead(btnSubmit, valid, data_target);
                    break;

                case "3":
                    datalayerSection = PmDRSDatalayer.ACCESSORIES_SECTION;
                    if (this.accessories.length > 0) {
                        this.sendLead(btnSubmit, true, data_target);
                    } else {
                        this.sendLead(btnSubmit, true, data_target);
                    }
                    break;

                case "4":
                    datalayerSection = PmDRSDatalayer.PAYMENT_SECTION;
                    this.sendLead(btnSubmit, true, data_target);
                    break;
                default:
                    console.log("case default");
                    break;
            }

            let vehicle = {
                vin: this.app.config.vehicle.vin,
                condition: this.app.config.vehicle.condition,
                year: this.app.config.vehicle.year,
                make: this.app.config.vehicle.make,
                model: this.app.config.vehicle.model,
                trim: this.app.config.vehicle.trim,
            }
            this.app.pmDRSDatalayer.submitEvent(datalayerSection, "submit button", event.target, this.leadId, vehicle);
        });


        DOMHelper.addHandler(dealPage.getSelector("#easy-ride-disclaimer"), "click", () => {
            let disclaimer = document.querySelector(dealPage.getSelector("#disclaimer-easyride-text"));
            if (disclaimer.style.display == "none") {
                return (disclaimer.style.display = "block");
            }
            return (disclaimer.style.display = "none");
        });

        this.registerNextEvents(dealPage.getSelector("button.btn-next"));
        this.registerStepButtonsEvents(dealPage.getSelector("li.step-btn"));

        // this.downPaymentSlider.setOnChange(() => {
        //     this.updateCashValue();
        //     refreshFinanceMonthlyPayment();
        // });
        // this.tradeInSlider.setOnChange(() => {
        //     this.updateCashValue();
        //     refreshFinanceMonthlyPayment();
        // });

        DOMHelper.addHandler(dealPage.getSelector(".ciMobileNumber"), "keyup", (event) => {
            if (event.target.value != "") {
                event.target.value = FormatHelper.phoneNumberFormat(event.target.value);
            }
        });        

        // define events
        let leaseRadioButtonsEvent = function () {
            dealPage.dealType = "lease";
            dealPage.paymentSection.populateCreditScoreSelect();
            dealPage.paymentSection.populateTermSelect("term-lease", "lease");
            DOMHelper.setInnerHTML(dealPage.getSelector(".vehicle-lease-type"), dealPage.dealType);
            dealPage.updateMonthlyPayment(dealPage.dealType);
            document.querySelector(dealPage.getSelector(".miles-per-year")).style.display = "block";
        };

        let financeRadioButtonsEvent = function (event) {
            if (event.target.classList.contains("drs-input-poFinance")) return;
            document.querySelector(dealPage.getSelector(".miles-per-year")).style.display = "none";
            dealPage.dealType = "finance";
            dealPage.paymentSection.populateCreditScoreSelect();
            dealPage.paymentSection.populateTermSelect("term", "finance");

            DOMHelper.setInnerHTML(dealPage.getSelector(".vehicle-lease-type"), dealPage.dealType);
            // document.querySelector(dealPage.getSelector("#credit-score-dealPage")).style.display = "inline";
            document.querySelectorAll(dealPage.getSelector("span.balloon-text-container")).forEach((elem) => {
                elem.style.display = "none";
            });
            dealPage.updateMonthlyPayment(dealPage.dealType);
        };

        let cashRadioButtonEvent = function () {
            let vehicleData = {
                imageSrc: dealPage.app.config.vehicle.imgUrl,
                infoPayment: document.querySelector(dealPage.getSelector(".vehicle-price")),
                vehicleName: dealPage.app.config.vehicle.label,
            };
            document.querySelector(dealPage.getSelector(".miles-per-year")).style.display = "none";
            let msrp = dealPage.app.getVehicleRetailPrice();
            dealPage.dealType = "cash";
            dealPage.updateCashHeaderValue();
            let paymentData = {
                downPayment: dealPage.downPaymentSlider.getValue() + dealPage.tradeInSlider.getValue(),
                tradeIn: dealPage.tradeInSlider.getValue(),
            };
            dealPage.seeDetails.updateValues(paymentData, null, dealPage.dealType, msrp, vehicleData);
            // document.querySelector(dealPage.getSelector("#credit-score-dealPage")).style.display = "none";
            document.querySelectorAll(dealPage.getSelector("span.balloon-text-container")).forEach((elem) => {
                elem.style.display = "none";
            });
            dealPage.paymentSection.updateCashValue();
            document.querySelector(dealPage.getSelector(".vehicle-lease-type-months")).style.display = "none";
            document.querySelector(dealPage.getSelector(".vehicle-lease-type-taxes")).style.display = "none";
            let monthsHeader = document.querySelector(dealPage.getSelector(".vehicle-lease-type-taxes"));
            monthsHeader.classList.remove("payment-monts-value-before");
        };

        let balloonRadioButtonEvent = function (event) {
            if (event.target.classList.contains("drs-input-poBalloon")) return;

            document.querySelector(dealPage.getSelector(".miles-per-year")).style.display = "none";
            let allowed = dealPage.app.balloonTable().allowed;
            if (allowed) {
                dealPage.dealType = "balloon";
                dealPage.paymentSection.populateCreditScoreSelect();
                dealPage.paymentSection.populateTermSelect("term-balloon", "balloon");
                DOMHelper.setInnerHTML(dealPage.getSelector(".vehicle-lease-type"), dealPage.dealType);
                // document.querySelector(dealPage.getSelector("#credit-score-dealPage")).style.display = "inline";
                document.querySelector(dealPage.getSelector("span.balloon-text-container")).style.display = "block";
                dealPage.updateMonthlyPayment(dealPage.dealType);
            }
        };

       

        let needHelpEvent = function () {
            dealPage.needHelpFormModal.show();
        };

        // events for step 6 - schedule delivery
        // let ourDealershipEvent = function () {
        //     let anotherLocationDiv = document.querySelector(
        //         dealPage.getSelector(".another-location-info")
        //     );
        //     anotherLocationDiv.style.display = "none";
        // };

        // let anotherLocationEvent = function () {
        //     let anotherLocationDiv = document.querySelector(
        //         dealPage.getSelector(".another-location-info")
        //     );
        //     anotherLocationDiv.style.display = "block";
        // };
                

        // let modalBody = document.querySelector(".drs-modal-body");
        // modalBody.addEventListener("scroll", function () {
        //     const scrollPosition = modalBody.scrollTop;
        //     let isMobile = window.innerWidth < 768 ? true : false;
        //     const headerInfo = document.querySelector(dealPage.getSelector(".vehicle-info-mobile"));
        //     const headerImg = document.querySelector(dealPage.getSelector(".vehicle-info-mobile .v-image-wrapper img"));
        //     const paymentBlue = document.querySelector(
        //         dealPage.getSelector(".vehicle-info-mobile .v-info .v-info-payment")
        //     );
        //     const stepNumbers = document.querySelector(dealPage.getSelector(".step-numbers"));
        //     const accLength = dealPage.accessories.length;

        //     // make header smaller
        //     if (scrollPosition > 0) {
        //         if (accLength > 0) {
        //             paymentBlue.classList.add("payment-price-smaller");
        //         } else {
        //             paymentBlue.classList.add("payment-price-smaller-no-acc");
        //         }
        //         headerInfo.classList.add("header-deal-page-smaller");
        //         isMobile ? headerImg.classList.add("img-smaller-mobile") : headerImg.classList.add("img-smaller");
        //         stepNumbers.classList.add("step-numbers-small");
        //     } else {
        //         // make header bigger again
        //         if (accLength > 0) {
        //             paymentBlue.classList.remove("payment-price-smaller");
        //         } else {
        //             paymentBlue.classList.remove("payment-price-smaller-no-acc");
        //         }
        //         headerInfo.classList.remove("header-deal-page-smaller");
        //         isMobile ? headerImg.classList.remove("img-smaller-mobile") : headerImg.classList.remove("img-smaller");
        //         stepNumbers.classList.remove("step-numbers-small");
        //     }
        // });

        DOMHelper.addHandler(dealPage.getSelector("#submitFloatButton"), 'click', needHelpEvent)        


        DOMHelper.addHandler(this.getSelector(".drs-input-poLease"),
            "click", 
            leaseRadioButtonsEvent
        );

        DOMHelper.addHandler(this.getSelector(".drs-input-poFinance"),
            "click", 
            financeRadioButtonsEvent
        );

        DOMHelper.addHandler(this.getSelector(".drs-input-poBalloon"),
            "click", 
            balloonRadioButtonEvent
        );

        DOMHelper.addHandler(this.getSelector(".drs-input-poCash"),
            "click", 
            cashRadioButtonEvent
        );

        // let ourDealershipButton = document.querySelector(
        //     dealPage.getSelector("#ourDealership")
        // );
        // ourDealershipButton.addEventListener("click", ourDealershipEvent);

        // let anotherLocationButton = document.querySelector(
        //     dealPage.getSelector("#anotherLocation")
        // );
        // anotherLocationButton.addEventListener("click", anotherLocationEvent);

        
        // document.addEventListener("click", function (e) {
        //     if (e.target && e.target.id == "btn-taxes-fees") {
        //         dealPage.applyTaxes();
        //     }
        // });

        let submitRetailingForm = function (event) {
            console.log("***** ***** ***** ***** MESSAGE FROM DEAL PAGE ***** ***** ***** *****");
            console.log("submit");
            event.preventDefault();
            event.stopPropagation();

            // let balloonError = document.querySelector(dealPage.getSelector(".header-error-text"));
            // let financeError = document.querySelector(dealPage.getSelector(".header-error-finance"));

            if (dealPage.dealType == "balloon" || dealPage.dealType == "cash") {
                // if not present, send the lead
                // if (balloonError.style.display == "none") {
                    // document.querySelector(dealPage.getSelector(".header-lead-error")).style.display = "none";
                    //Stripe Payment then save the lead
                    if (dealPage.paymentSection.makeDownPayment) {
                        dealPage.paymentSection.processPayment((paymentIntent) => {
                            dealPage.stripePaymentId = paymentIntent.id;
                            dealPage.saveLead(event);
                        });
                    } else {
                        //Only save the lead
                        dealPage.saveLead(event);
                    }
                // } else {
                //     document.querySelector(dealPage.getSelector(".header-lead-error")).style.display = "block";
                // }
            } else {
                // if (financeError.style.display == "none") {
                //     document.querySelector(dealPage.getSelector(".header-lead-error")).style.display = "none";
                    //Stripe Payment then save the lead
                    if (dealPage.paymentSection.makeDownPayment) {
                        dealPage.paymentSection.processPayment((paymentIntent) => {
                            dealPage.stripePaymentId = paymentIntent.id;
                            dealPage.saveLead(event);
                        });
                    } else {
                        //Only save the lead
                        dealPage.saveLead(event);
                    }
                // } else {
                //     document.querySelector(dealPage.getSelector(".header-lead-error")).style.display = "block";
                // }
            }
            return false;
        };

        

        // let submitFromButton = function () {
        //     let form = document.querySelector(
        //         dealPage.getSelector(".deal-page-form")
        //     );
        //     let event = {
        //         target: form,
        //     };

        //     dealPage.saveLead(event);
        // };

        let dealPageForm = document.querySelector(this.getSelector(".deal-page-form"));
        // let floatingButton = document.querySelector(
        //     dealPage.getSelector(".submit-floating-button #submitFloatButton")
        // );
        dealPageForm.addEventListener("submit", submitRetailingForm);

        
        // floatingButton.addEventListener("click", submitFromButton);

        // DOMHelper.addHandler(
        //     this.getSelector(".deal-page-body form"),
        //     "submit",
        //     submitRetailingForm
        // );

        // still necessary methods?
        //Taxes ZIP SUBMIT
        let taxesZipSubmit = function (event) {
            event.preventDefault();
            //FORM DATA AS JSON
            const data = new FormData(event.target);
            const values = Object.fromEntries(data.entries());

            dealPage.app.pmdrs.pmApi.zipCodeFinderInfo(values.zipcode, (response) => {
                console.log(response);
                let cities = JSON.parse(response);
                let citiesBoxesHTML = "";
                cities.forEach((item) => {
                    citiesBoxesHTML += dealPage.getCityBoxHtml(item);
                });
                DOMHelper.setInnerHTML(dealPage.getSelector("#pmdrs-taxes-cities-container"), citiesBoxesHTML);
                DOMHelper.addHandler(dealPage.getSelector("form.pmdrs-taxes-city-form"), "submit", taxesCitySubmit);
                DOMHelper.addHandler(dealPage.getSelector("form.pmdrs-taxes-city-form"), "click", (event) => {
                    DOMHelper.triggerEvent(event.target, "submit");
                });
            });

            console.log("submit");
            return false;
        };

        DOMHelper.addHandler(this.getSelector(".form-card-btn"), "click", (event) => {
            alert(event.target.dataset["target"]);
        });
        let taxesCitySubmit = function (event) {
            event.preventDefault();
            //FORM DATA AS JSON
            const data = new FormData(event.target);
            const values = Object.fromEntries(data.entries());
            DOMHelper.removeClass("form.pmdrs-taxes-city-form", "active");
            event.target.classList.add("active");
            let vehicle = dealPage.app.config.vehicle;

            paymentData.state = values.state;
            paymentData.city = values.city;
            paymentData.county = values.county;

            dealPage.app.getMonthlyPayment(
                true,
                dealPage.dealType,
                paymentData,
                (response) => {
                    let paymentsData = JSON.parse(response);
                    dealPage.updatePricingDetail(paymentsData);
                    // dealPage.app.widget.updateMonthlyPayment(dealPage.dealType);
                },
                (errorResponse) => {
                    console.log(errorResponse);
                    alert("API error, check console");
                }
            );
        };

        DOMHelper.addHandler(this.getSelector("form#pmdrs-taxes-zip-form"), "submit", taxesZipSubmit);
    }

    setUrlToEasyRideLink() {    
        DOMHelper.setAttribute(this.getSelector('.balloon-learnmore-btn'), 
            "href", 
            "https://www.bmwmotorcycles.com/en/financial-services/easy-ride.html"
        );
    }

    // getSessionVars() {
    //     let params = [
    //         'sd_campaign', 'sd_digadprov', 'sd_channel', 'sd_campaign_type', 'sd_digadcid', 'sd_adid', 'adid', 'kwid',
    //         'sd_digadid', 'sd_digadkeyword', 'sd_location', 'sd_placement', 'sd_targetid',
    //         'fbclid', //cornhusker
    //         'gclid',
    //         'fca_campaign', 'fca_digadprov', 'fca_channel', 'fca_campaign_type', 'fca_program', 'fca_adid',
    //         'fca_digadcid', 'fca_keyword', 'fca_agid', 'fca_mm'
    //     ];
    //     let url = window.location.href;
    //     let urlParams = new URLSearchParams(window.location.search);
    //     let matched = {};
    //     params.forEach(param => {
    //         if (urlParams.has(param)) {
    //             matched[param] = urlParams.get(param);
    //         }
    //     });

    //     return matched;
    // }

    getRandomeHexString(length) {
        let randomChars = "abcdef0123456789";
        let result = "";
        for (let i = 0; i < length; i++) {
            result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
        }
        return result;
    }

    // This function containes additional data that it's not part of the form, like session or env stuff
    // Do not introduce specific form logic here because this function is shared with more forms.
    addExtraFormData(formData){
        let site_token = this.app.pmdrs.config.accountId;
        let user_agent = navigator.userAgent;
        let source_url = window.location.href.replace(window.location.origin, "").substring(1);
        let source_origin = window.location.origin;
        let make = this.app.config.vehicle.make;
        let model = this.app.config.vehicle.model;
        let trim = this.app.config.vehicle.trim;
        let vehicleField = {
            vin: this.app.config.vehicle.vin,
            stockNum: this.app.config.vehicle.stockNumber,
            label: this.app.config.vehicle.label,
            year: this.app.config.vehicle.year,
            msrp: this.app.getVehicleRetailPrice(),
            make: make,
            model: model,
            trim: trim,
            key: `${this.app.config.vehicle.year}${make.toLowerCase()}${model.toLowerCase()}${trim
                .toLowerCase()
                .replace(/\s/g, "")}`,
        };

        formData.set("sessionVars", JSON.stringify(this.app.pmdrs.getLeadSessionVars()));
        formData.set("vehicleField", JSON.stringify(vehicleField));                
        formData.set("customerId", this.drsCustomerId);
        formData.set("sessionId", this.app.pmDRSDatalayer.getSessionId());
        formData.set("sessionIdSource", this.app.pmdrs.sessionIdSource || "host");
        // "external" on DDC/embed hosts: pm-motors-api then links the lead to the DRA dashboard instead of wp-admin
        formData.set("websiteProviderId", this.app.pmdrs.config.websiteProviderId || "pixelmotion");
        if(this.stripePaymentId){
            formData.set("stripePaymentId", this.stripePaymentId);        
        }
        formData.set("user_agent", user_agent);
        formData.set("source_url", source_url);
        formData.set("source_origin", source_origin);
        formData.set("site_token", site_token);
        formData.set("leadOEM", this.app.pmdrs.config.oem);
        formData.set("isFCA", this.app.pmdrs.config.oem);
        formData.set("vinField", this.app.config.vehicle.vin);
        formData.set("multiDealer", this.app.pmdrs.config.isMultiDealer);        
        let ftid = formData.get("ftid");
        if(ftid){
            const ftidTimestamp = ftid.substring(ftid.indexOf(':') + 1);
            formData.set("ftidTimestamp", ftidTimestamp);                    
        }        

        formData.set("paymentOptionsField", this.dealType);
        formData.set("paymentOptionsFieldTouched", this.dealTypeTouched);
        let paymentOptionsField = formData.get("paymentOptionsField") ?? this.dealType;
        let payment = this.app.paymentData[paymentOptionsField];
         if (paymentOptionsField == "balloon") {// || paymentOptionsField == "premier" || paymentOptionsField == "ttf"
            formData.set("paymentField", payment.monthlyPayment);
            formData.set("balloonPaymentField", payment.balloonPayment);
        } else if (paymentOptionsField == "cash") {
            formData.set("paymentField", 0);
        } else formData.set("paymentField", payment.monthlyPayment);

        // lease-only (LenderDesk); backend defaults both to null when absent, so skip
        // entirely on finance/cash rather than sending undefined/NaN
        if (paymentOptionsField == "lease") {
            if (payment.residualValue != null) {
                formData.set("residualValueField", payment.residualValue);
            }
            if (payment.residualPercentage != null && !Number.isNaN(payment.residualPercentage)) {
                formData.set("residualPercentageField", payment.residualPercentage);
            }
        }
        formData.set("monthlyTermField", this.setMonthlyTerm(this.dealType));
        formData.set("monthlyTermFieldTouched", this.paymentSection.termTouched);
        formData.set("mpyFieldTouched", this.paymentSection.mpyTouched);
        formData.set("downPaymentFieldTouched", this.paymentSection.cashDownTouched);
        formData.set("makeDepositFieldTouched", this.paymentSection.makeDownPaymentTouched);
        formData.set("creditscoreFieldTouched", this.paymentSection.creditScoreTouched);
        formData.set("tradeInFieldTouched", this.tradeInSection?.includeTradeInTouched ?? false);
        formData.set("aprField", this.paymentSection.getMoneyFactorText(this.dealType));
        formData.set("taxesValueField", this.paymentSection.getFeesAndTaxesTotal());
        formData.set("feesAndTaxesCompleted", this.paymentSection.feesAndTaxesCompleted);

        //Consent fields are present in all Brands, initially were only on BMW
        formData.set("tcpa_descriptionField", this.contactFormSection.consents.tcpa);
        formData.set("ccpa_descriptionField", this.contactFormSection.consents.ccpa);

        // only the boxes actually checked: the text-message one (#tcpa) is optional for Email contact
        let consentChecked = (id) => !!document.querySelector(this.contactFormSection.getSelector(id))?.checked;
        formData.set("tcpa_textField", consentChecked("#tcpa-checkbox") ? "I agree TCPA consent" : "");
        formData.set("ccpa_textField", consentChecked("#ccpa-checkbox") ? "I agree CCPA consent" : "");
        // pm-motors-api writes these into the ADF consent tags (Lead.php), which read false when they're missing
        formData.set("tcpa_consentField", consentChecked("#tcpa-checkbox") ? "1" : "");
        formData.set("ccpa_consentField", consentChecked("#ccpa-checkbox") ? "1" : "");
        
        const hashedEmail = formData.get('email');
        formData.set("hashedEmail", hashedEmail);

        formData.set("gacookies", JSON.stringify(this.getGaCookies()));
        formData.set("sdSessionId", this.getGaCookies().sdSessionId ?? "");

        return formData;
    }

    setMonthlyTerm(dealType) {
        let months = 0;
        switch (dealType) {
            case "balloon":
                months = this.getRetailingTypeSelect("term-balloon").value;
                break;

            case "finance":
                months = this.getRetailingTypeSelect("term").value;
                break;

            case "lease":
                months = this.getRetailingTypeSelect("term-lease").value;
                break;

            // case "premier":
            //     months = this.getRetailingTypeSelect("term-premier").value;
            //     break;

            // case "ttf":
            //     months = this.getRetailingTypeSelect("term-ttf").value;
            //     break;
            default:
                break;
        }
        return months;
    }

    getCookieValue(name) {
        let match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[2]) : null;
    }

    getGaCookies() {
        let sbjsCurrent = this.getCookieValue("sbjs_current");
        let sbjsPromo = this.getCookieValue("sbjs_promo");
        // the cookie only exists on PM WordPress sites; elsewhere ask Shift's tag directly
        let sdSessionId = this.getCookieValue("sdSessionId") || this.app.pmdrs.getShiftSessionId();

        return {
            sbjs_current: sbjsCurrent,
            sbjsPromo: sbjsPromo,
            sdSessionId: sdSessionId,
        };
    }

    saveLead(lead) {
        var $this = this;
        this.showLoading()
        this.paymentSection.disableSubmitBtn();
        var dealPageForm = new FormData(lead.target);
        let accessoriesField = [];
        let accessoriesSelected = document.querySelectorAll(this.getSelector(".accessory-selected"));

        // let creditscoreField = dealPageForm.get("creditscoreField");
        // let rangeConfig = this.app.getCreditRangeConfig(this.dealType);
        // creditscoreField = this.creditScoreToNumbers(creditscoreField, rangeConfig);
        let creditscoreStr = this.paymentSection.getCurrentCreditScoreRangeStr();
        dealPageForm.set("creditscoreField", creditscoreStr);
        // omit rather than send "0"/"null" when no valuation ever ran, so a genuine $0
        // appraisal stays distinguishable from "customer never ran a valuation"
        if (this.tradeInValue !== null) {
            dealPageForm.set('tradeInValueField', this.tradeInValue);
        }
        dealPageForm.set("leadId", this.leadId);
        dealPageForm.set("ftid", this.ftid);

        accessoriesSelected.forEach((selected) => {
            let img = selected.querySelector(".accessory-img");
            let id = img.dataset.id;
            let acc = $this.accessoriesSection.getAccessoryById(id);
            if(!acc){
                console.error("Accessory not found, please investigate id: " + id);
                return;
            }

            if (acc.product_type == "package") {
                let accs = acc.accessories;
                Object.keys(accs).forEach((accKey) => {
                    let accessory = {
                        id: accs[accKey]._id,
                        title: accs[accKey].name,
                        price: accs[accKey].price,
                        sku: accKey,
                    };
                    accessoriesField.push(accessory);
                });
            } else {
                let accessory = {
                    id: img.dataset.id,
                    title: img.dataset.title,
                    price: img.dataset.price,
                    sku: img.dataset.sku,
                };
                accessoriesField.push(accessory);
            }
        });

     
        dealPageForm.set("accessoriesField", JSON.stringify(accessoriesField));
        // dealPageForm.set("sessionVars", JSON.stringify(this.getSessionVars()));//removed to use injected session vars in pmdrs.config.hostSessionVars
        

        var tradeInVehicle = null;
        // setting trade-in custom
        if (this.getTradeInEnable()) {
            this.tradeInSection.imagesTradeIn.forEach((image) => {
                dealPageForm.append("vehicleImages[]", image);
            });
            // let usingInputText = document.querySelector(this.getSelector(".trade-in-no-vin-input-text"));
            // let tradeInType = this.app.siteSettings.tradeInType ?? "manual";
            // if (usingInputText && usingInputText.style.display == "block" && tradeInType == "manual") {
            //     let year = document.querySelector(this.getSelector("#tradeYearField"));
            //     let make = document.querySelector(this.getSelector("#tradeMakeField"));
            //     let model = document.querySelector(this.getSelector("#tradeModelField"));
            //     let trim = document.querySelector(this.getSelector("#tradeTrimField"));
            //     dealPageForm.set("tradeYearField", year.value);
            //     dealPageForm.set("tradeMakeField", make.value);
            //     dealPageForm.set("tradeModelField", model.value);
            //     dealPageForm.set("tradeTrimField", trim.value);
            //     dealPageForm.set("tradeInvinField", "");
            // }
            // if (tradeInType != "manual") {
            //     let year = this.getRetailingTypeSelect("year-trade-in").value;
            //     let make = this.getRetailingTypeSelect("make-name-trade-in").value;
            //     let model = this.getRetailingTypeSelect("model-trade-in").value;
            //     let trim = this.getRetailingTypeSelect("trim-trade-in").value;
            //     dealPageForm.set("tradeYearField", year);
            //     dealPageForm.set("tradeMakeField", make);
            //     dealPageForm.set("tradeModelField", model);
            //     dealPageForm.set("tradeTrimField", trim);
            // }
            let year = document.querySelector(this.tradeInSection.getSelector(".tradeYearField"));
            let make = document.querySelector(this.tradeInSection.getSelector(".tradeMakeField"));
            let model = document.querySelector(this.tradeInSection.getSelector(".tradeModelField"));
            let trim = document.querySelector(this.tradeInSection.getSelector(".tradeTrimField"));
            dealPageForm.set("tradeYearField", year.value);
            dealPageForm.set("tradeMakeField", make.value);
            dealPageForm.set("tradeModelField", model.value);
            dealPageForm.set("tradeTrimField", trim.value);

            tradeInVehicle = {
                make: make.value,
                model: model.value,
                year: year.value,
            }

            //DATALAYER trade in
            this.app.shiftDatalayer.fireEvent('drTradeInFinish')

        }

        //ADD TAXES
        if(this.paymentSection.isUsingTaxes()){
            var taxesList = this.paymentSection.getFeesAndTaxesList();
            if(taxesList){
                for (let index = 0; index < taxesList.length; index++) {
                    const taxesItem = taxesList[index];
                    dealPageForm.append(`taxes[${index}][label]`, taxesItem.label);                    
                    dealPageForm.append(`taxes[${index}][amount]`, taxesItem.amount);                    
                }
            }
        }

        dealPageForm = this.addExtraFormData(dealPageForm);
        let emailField = dealPageForm.get('emailField');
        let isFinalSubmit = this.drsCustomerId.length > 0;

        //CUSTOMER STATUS
        dealPageForm.set("drsCustomerStatus", "partial");
        if (isFinalSubmit) {
            dealPageForm.set("drsCustomerStatus", "complete");
        }

        this.app.pmdrs.pmApiDtm.postLead(
            dealPageForm,
            (response) => {
                console.log(JSON.parse(response));
                this.hideLoading();
                this.paymentSection.enableSubmitBtn();
                if (this.paymentSection.makeDownPayment) {
                    this.thankYouModal.updateSecondaryMessage(this.paymentSection.downPaymentDeposit);
                }
                this.thankYouModal.submissionModal.show(); // here the second modal is shown
                // let isFCA = this.app.pmdrs.isFCA();
                if (this.app.pmdrs.config.accountId == "delamomotorsports")
                    this.showAdditionalStepsInfo();
                // this.app.dealPage.submissionModal.show();

                //DATALAYER
                let updateCustomerJourney = () => {};
                if (isFinalSubmit) {
                    updateCustomerJourney = () => {
                        let CJData = {
                            CJId: this.customerJourneyId,
                            sessionId: this.app.pmDRSDatalayer.getSessionId()
                        };
                        this.app.pmdrs.pmCustomerAPI.updateCustomerJourney(CJData,
                            (success) => {
                                console.log(JSON.parse(success));
                            },
                            (xhr, status, error) => {
                                console.log(xhr);
                                console.log(status)
                                console.log(JSON.parse(error));
                            }
                        );
                    }
                }
                this.app.pmDRSDatalayer.submitEvent(PmDRSDatalayer.PAYMENT_SECTION, 'submit button', this.paymentSection.getSubmitBtn(), this.leadId, this.app.config.vehicle, updateCustomerJourney());
                this.app.shiftDatalayer.fireEvent('formSubmission', {formType: 'Other', leadId:this.ftid})
                this.paymentSection.setSubmitBtnSent();
                
                    this.app.pmdrsForms.stellantisHashEmail(emailField)
                        .then((hashedEmail) =>{
                            this.app.adobeDtmDatalayer.fireEvent('formSubmit', {
                                formType: 'confirm-deal',
                                leadId:this.ftid,
                                hashedEmail,
                                tradeInVehicle: (this.tradeInSection?.includeTradeIn) ? tradeInVehicle : null
                            });
                        });
                
            },
            (error) => {
                console.log(error);
            }
        );

        //SAVE CUSTOMER
        this.app.pmdrs.pmCustomerAPI.saveCustomer(dealPageForm, (response) => {
            response = JSON.parse(response);
            console.log("Customer save response");
            console.log(response);
            this.drsCustomerId = response.id;
        });
    }

    // creditScoreToNumbers(creditscoreField, rangeConfig) {
    //     console.log(creditscoreField);
    //     console.log(rangeConfig);
    //     let creditScore = "";
    //     if (this.dealType == "cash") return 0;
    //     rangeConfig = this.dealType == "lease" ? Object.values(rangeConfig) : rangeConfig;
    //     if (this.dealType == "premier") {
    //         let label = "Premier Tier 1";
    //         creditScore = rangeConfig.find((element) => element.label == label);
    //     } else {
    //         creditScore = rangeConfig.find((element) => element.label === creditscoreField);
    //     }

    //     return creditScore.min + " - " + creditScore.max;
    // }

    changeSizeScreen(modalBody, vehicleInfo, image) {
        if (window.innerWidth <= 1024) {
            image.style.display = "block";
        }
        document.querySelectorAll(".vehicle-lease").forEach((elem) => (elem.style.fontSize = "20px"));
        document.querySelector(".header-deal-page").classList.remove("small-header");
        // document
        //     .querySelector(".v-image-wrapper img")
        //     .classList.remove("small-header-img");
        // document
        //     .querySelector(".header-deal-page")
        //     .classList.remove("header-big-screen");
    }

    detectBrowser() {
        if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) != -1) {
            return "Opera";
        } else if (navigator.userAgent.indexOf("Chrome") != -1) {
            return "Chrome";
        } else if (navigator.userAgent.indexOf("Safari") != -1) {
            return "Safari";
        } else if (navigator.userAgent.indexOf("Firefox") != -1) {
            return "Firefox";
        } else if (navigator.userAgent.indexOf("MSIE") != -1 || !!document.documentMode == true) {
            return "IE";
        } else {
            return "Unknown";
        }
    }

    getCityBoxHtml(cityObject) {
        return (
            `
            <form class="pmdrs-taxes-city-form">
                <input type="hidden" name="zipCode" value="` +
            cityObject.zipCode +
            `" />
                <input type="hidden" name="state" value="` +
            cityObject.state +
            `" />
                <input type="hidden" name="county" value="` +
            cityObject.county +
            `" />
                <input type="hidden" name="city" value="` +
            cityObject.city +
            `" />
                <div>` +
            cityObject.city +
            `</div>
                <p>` +
            cityObject.state +
            " - " +
            cityObject.zipCode +
            `</p>

            </form>
        `
        );
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAtt + " " + selector);

    }

    isAccessoriesSectionAllowed() {        
        return this.app.config.vehicle.accessories 
        && typeof this.app.config.vehicle.accessories === "object"
        && Object.keys(this.app.config.vehicle.accessories).length > 0;

    }

    rearrangeSectionsForLampedodge() {
        // Add scoping class so CSS can target lampedodge-specific layout
        const panel = document.querySelector(this.app.getSelector('.pmdrspanel'));
        if (panel) panel.classList.add('lampedodge-layout');

        const form = this.getFormElement();
        const paymentSection = form.querySelector('#your-payment-section');
        if (!paymentSection) return;

        // Desired order:
        // 1. Estimated Payment (payment option boxes)
        // 2. Down Payment (.your-payment-section--downpayment)
        // 3. Offers (.pmdrs-incentives-container #1)
        // 4. Explore Conditional Offers (.pmdrs-incentives-container #2)
        // 5. Trade In (#tradein-section)
        // 6. Payment Summary (.payment-summary-section)
        // 7. Contact Information (.contact-form-section)
        //
        // Credit Score/Down Payment/Credit Application/Payment Summary are now their own
        // sibling cards (not nested inside #your-payment-section) as of the finance-estimate
        // redesign — found via `form` (whole page), not `paymentSection` (payment-boxes card only).

        const downPaymentSection = form.querySelector('.your-payment-section--downpayment');
        const paymentSummary   = form.querySelector('.payment-summary-section');
        const offersContainers = Array.from(paymentSection.querySelectorAll('.pmdrs-incentives-container'));
        const lastPaymentBox   = paymentSection.querySelector('.cash-box.payment-option-box');

        // 2. Move Down Payment after last payment-option-box
        if (lastPaymentBox && downPaymentSection) {
            lastPaymentBox.after(downPaymentSection);
        }

        // 3 & 4. Move Offers and Explore Conditional Offers after Down Payment
        if (downPaymentSection && offersContainers.length > 0) {
            let anchor = downPaymentSection;
            offersContainers.forEach(c => {
                anchor.after(c);
                anchor = c;
            });
        }

        // 5. Move trade-in (trigger + section, + its separate vehicle-info card) to after the payment section
        const tradeInTrigger = form.querySelector('.trigger-element[data-index="2"]');
        const tradeInSection = form.querySelector('#tradein-section');
        const tradeInVehicleInfoSection = form.querySelector('.tradein-vehicle-info-section');
        if (tradeInTrigger && tradeInSection) {
            paymentSection.after(tradeInSection);
            paymentSection.after(tradeInTrigger);
            if (tradeInVehicleInfoSection) {
                tradeInSection.after(tradeInVehicleInfoSection);
            }
        }

        // 3 & 4 (redesign). Offers are their own card outside #your-payment-section, so
        // offersContainers above finds nothing there — keep the card between payment and trade-in
        const offersCard = form.querySelector('.your-payment-section--offers');
        if (offersCard) {
            paymentSection.after(offersCard);
        }

        // 6. Move Payment Summary after trade-in (outside #your-payment-section)
        const lastTradeInEl = tradeInVehicleInfoSection || tradeInSection;
        if (paymentSummary && lastTradeInEl) {
            lastTradeInEl.after(paymentSummary);
        } else if (paymentSummary) {
            paymentSection.after(paymentSummary);
        }

        // 7. Contact Information (.contact-form-section) is already last — no move needed
    }

    // Southbay DRA Changes [need asap] (2026-09-14): Down Payment moved from its own
    // card further down the page to sit between the Estimated Conventional Finance and
    // Estimated Cash boxes. Southbay only offers finance/cash (see PmSiteSettings
    // paymentTypes), so anchoring after the finance box lands it directly before cash.
    rearrangeSectionsForSouthbay() {
        const form = this.getFormElement();
        const paymentSection = form.querySelector('#your-payment-section');
        if (!paymentSection) return;

        const downPaymentSection = form.querySelector('.your-payment-section--downpayment');
        const financeBox = paymentSection.querySelector('.finance-box.payment-option-box');

        if (financeBox && downPaymentSection) {
            financeBox.after(downPaymentSection);
        }
    }

    // Southbay DRA Changes [need asap] (2026-09-14): "Estimated Cash" box title renamed to
    // "Cash Purchase". The box title is static HTML (only the balloon title is re-rendered by
    // JS today), so it needs a direct one-time text swap. The Payment Summary's own "selected
    // option" label for cash is handled separately in PaymentSection.getPaymentOptionText().
    renameCashBoxForSouthbay() {
        const cashBoxTitle = this.getFormElement().querySelector('.cash-box-title');
        if (cashBoxTitle) cashBoxTitle.textContent = 'Cash Purchase';
    }

    getTradeInEnable() {
        return this.app.siteSettings.tradeInEnable;
    }

    getAwayMessage() {
        return this.awayMessageEnable;
    }
}
